function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Legend"
}, React.createElement("g", {
  fill: "#fff",
  fontSize: 13
}, React.createElement("text", {
  fontFamily: "Montserrat-Bold",
  transform: "translate(2.443 428.016)"
}, "Water Needs"), React.createElement("text", {
  fontFamily: "Montserrat-Regular",
  transform: "translate(95.243 428.016)"
}, "in 2040"), React.createElement("text", {
  fontFamily: "Montserrat-Regular",
  transform: "translate(2.443 443.616)"
}, "(acre-feet)")), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 463.91)"
}, "0-100"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 478.41)"
}, "100-500"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 492.91)"
}, "500-2000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 507.41)"
}, "2000-5000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 521.91)"
}, "5000-15000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 536.41)"
}, "15000-50000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 550.91)"
}, "50000-100000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 11,
  transform: "translate(22.659 565.41)"
}, "100000-500000"), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_1_",
  d: "M2.4 452.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_2_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_1_"
})), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M2.4 452.7h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_2_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_3_",
  d: "M2.4 452.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_4_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_3_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_5_",
  d: "M2.4 467.4h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_6_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_5_"
})), React.createElement("path", {
  fill: "#5664ad",
  d: "M2.4 467.4h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_6_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_7_",
  d: "M2.4 467.4h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_8_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_7_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_9_",
  d: "M2.4 482.1h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_10_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_9_"
})), React.createElement("path", {
  fill: "#727eba",
  d: "M2.4 482.1h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_10_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_11_",
  d: "M2.4 482.1h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_12_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_11_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_13_",
  d: "M2.4 496.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_14_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_13_"
})), React.createElement("path", {
  fill: "#8e98c8",
  d: "M2.4 496.7h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_14_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_15_",
  d: "M2.4 496.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_16_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_15_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_17_",
  d: "M2.4 511.4h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_18_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_17_"
})), React.createElement("path", {
  fill: "#abb1d6",
  d: "M2.4 511.4h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_18_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_19_",
  d: "M2.4 511.4h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_20_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_19_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_21_",
  d: "M2.4 526.1h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_22_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_21_"
})), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M2.4 526.1h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_22_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_23_",
  d: "M2.4 526.1h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_24_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_23_"
})), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_25_",
  d: "M2.4 540.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_26_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_25_"
})), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M2.4 540.7h12.7v12.7H2.4z",
  clipPath: "url(#SVGID_26_)"
}), React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_27_",
  d: "M2.4 540.7h12.7v12.7H2.4z"
})), React.createElement("clipPath", {
  id: "SVGID_28_"
}, React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_27_"
})), React.createElement("path", {
  fill: "#fff",
  d: "M2.4 555.4h12.7v12.7H2.4z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Map"
}, React.createElement("path", {
  fill: "#abb1d6",
  d: "M286.9 425l30.9.3-.2-22.5-30.5.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M286.9 425l30.9.3-.2-22.5-30.5.3z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M315.8 493.5l1.2 4.3-.5 1.3.4 2.8-.9 1.4.2 2.1 1.3.3 1.7 2.1-.5 1.5 2.9 1.8-.3 1.3 2.6 1.8 1.2 2.7.1 2.1 1.4 1 .3 3.4 1.4 4.1 6.9-5 2.5-5.4v-23.8l-16.6-.2-1.6-2.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M315.8 493.5l1.2 4.3-.5 1.3.4 2.8-.9 1.4.2 2.1 1.3.3 1.7 2.1-.5 1.5 2.9 1.8-.3 1.3 2.6 1.8 1.2 2.7.1 2.1 1.4 1 .3 3.4 1.4 4.1 6.9-5 2.5-5.4v-23.8l-16.6-.2-1.6-2.3z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M337.7 182.3l.1 23 23 .2.3-23.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.7 182.3l.1 23 23 .2.3-23.2z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M157.8 205.2h20.5l.1-22.5h-20.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M157.8 205.2h20.5l.1-22.5h-20.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M483 217.6l7.6 6h5.7l4.1 2.3 1.4-.6 1 1.7 1.3-1.6v-23l-.9 2.6-21.5.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M483 217.6l7.6 6h5.7l4.1 2.3 1.4-.6 1 1.7 1.3-1.6v-23l-.9 2.6-21.5.1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M382.9 203l22.9.6.7-23.1-23.5-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M382.9 203l22.9.6.7-23.1-23.5-.1z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M146.3 272.9h23.1v-22.4h-11.6v4.4h-11.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M146.3 272.9h23.1v-22.4h-11.6v4.4h-11.5z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M361.6 401.7l9.5 11.6 20.3-17-5.8-6.6.9-1.2-10.7-.1-1.3.7-.9-3.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M361.6 401.7l9.5 11.6 20.3-17-5.8-6.6.9-1.2-10.7-.1-1.3.7-.9-3.9z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M377.3 325.4l2.6.8 1.5-1 1.7 1.2.1 1.3 2.1 1.7.8 3.7 1.5 1.3 2.6.7.4-.8 7.4-2.6 2.1 1.3.7-.5 2.9 1.2 4.9 3 7.8-2.8-5-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M377.3 325.4l2.6.8 1.5-1 1.7 1.2.1 1.3 2.1 1.7.8 3.7 1.5 1.3 2.6.7.4-.8 7.4-2.6 2.1 1.3.7-.5 2.9 1.2 4.9 3 7.8-2.8-5-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M381.3 525.6l-2 8 6.2.7v4.2l14.6 2.4.9-1.7 2.7.4 1.3-2.2-1.3-11.2-18.2.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M381.3 525.6l-2 8 6.2.7v4.2l14.6 2.4.9-1.7 2.7.4 1.3-2.2-1.3-11.2-18.2.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M337.8 159.3v-20l-1.7-.4-2.3 1.2-2.3-.7-4.1-.2-.9-6.5-2.2-3.5-2.6-.3-2.4-2.6-.9.9-.2 3.5-1.5.3-1.8-1.4v29.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.8 159.3v-20l-1.7-.4-2.3 1.2-2.3-.7-4.1-.2-.9-6.5-2.2-3.5-2.6-.3-2.4-2.6-.9.9-.2 3.5-1.5.3-1.8-1.4v29.7z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M360.9 159.2v-13l-2.7 1-3.3-3.7-3.8-1.6-1.8 1.6-3.4-.2-2.8-1.3-1.3.6-4-3.3v20z"
}), React.createElement("path", {
  fill: "none",
  d: "M360.9 159.2v-13l-2.7 1-3.3-3.7-3.8-1.6-1.8 1.6-3.4-.2-2.8-1.3-1.3.6-4-3.3v20z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M268.3 87.7h23.6V64.2h-23.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M268.3 87.7h23.6V64.2h-23.6z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M439 395l14.5 14.2 15-9.2 5.2-5.8-1.3-.1-.7-2.4-2.5-1.2.4-.8-2.2-4.1-.8.2-2.2-2.2 1.5-1.1-1.3-.8.6-1.4-.8-2.4-2.4-1.8-2.7-.5-5.8 6-1.7 5.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M439 395l14.5 14.2 15-9.2 5.2-5.8-1.3-.1-.7-2.4-2.5-1.2.4-.8-2.2-4.1-.8.2-2.2-2.2 1.5-1.1-1.3-.8.6-1.4-.8-2.4-2.4-1.8-2.7-.5-5.8 6-1.7 5.3z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M289.5 452.7l1.6 1.2 1.3 3.6 2.5.6-.2 2 1.6 1.4-.1 2.4.9.7.4 2.7 4.5 3.2 1.8 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.4-.7 3.3 2.1.8-1.1 7-1.4 1.1 1.8.7v1.6l1.8.3 3.7-2.7 1.6 2.3 23.4.3-.2-39.1-25.6 1.4-.3-8.7-35.8.4 2.4 1.5 3.1 1z"
}), React.createElement("path", {
  fill: "none",
  d: "M289.5 452.7l1.6 1.2 1.3 3.6 2.5.6-.2 2 1.6 1.4-.1 2.4.9.7.4 2.7 4.5 3.2 1.8 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.4-.7 3.3 2.1.8-1.1 7-1.4 1.1 1.8.7v1.6l1.8.3 3.7-2.7 1.6 2.3 23.4.3-.2-39.1-25.6 1.4-.3-8.7-35.8.4 2.4 1.5 3.1 1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M432.2 349l1.2 1.1 5.3-.3 1.1 5.1 1.6-1.1h2.9l10-1.6 5.6 2.2.7-.9-2-3.3 1.5-.3-.3-3 3.1-1.2.4-3-3.1-2.4.2-2-2.1-.6-3.2 1.2-1.2-1.1-2.6.5-6 2.3-6.3 1.5-2 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M432.2 349l1.2 1.1 5.3-.3 1.1 5.1 1.6-1.1h2.9l10-1.6 5.6 2.2.7-.9-2-3.3 1.5-.3-.3-3 3.1-1.2.4-3-3.1-2.4.2-2-2.1-.6-3.2 1.2-1.2-1.1-2.6.5-6 2.3-6.3 1.5-2 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M133.9 272.9l2.1 1 1.4-.5 1.1 2.1v4.4l.7 3 1.9 1.7 2.3-.4 2.5.9 3.3-.7.7 2 2.8.9 5.1.3.5-1 5.2 1.8 4.8 4.2 2.5-1.3v-18.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M133.9 272.9l2.1 1 1.4-.5 1.1 2.1v4.4l.7 3 1.9 1.7 2.3-.4 2.5.9 3.3-.7.7 2 2.8.9 5.1.3.5-1 5.2 1.8 4.8 4.2 2.5-1.3v-18.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M460.6 353.5l1.2 1 1.1 4.6-1.6 1.3.2 1.8 1.4 1-1.2 2 .8 1.5 2.3.3.8 3.8h2.7l6.3-3-5.9-19 5.4 4.1 1.5-.4v-7.8l-12.5.8-3.3 1.4.3 3-1.5.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M460.6 353.5l1.2 1 1.1 4.6-1.6 1.3.2 1.8 1.4 1-1.2 2 .8 1.5 2.3.3.8 3.8h2.7l6.3-3-5.9-19 5.4 4.1 1.5-.4v-7.8l-12.5.8-3.3 1.4.3 3-1.5.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M473 313.2l1.4 11.9 10.2 6.2 10.5.2 1.3-18-3 .1.7-1.2-2.3-2.9-.1-6.2-8 6.5-.5 1.6h-5.6l-1.2 1z"
}), React.createElement("path", {
  fill: "none",
  d: "M473 313.2l1.4 11.9 10.2 6.2 10.5.2 1.3-18-3 .1.7-1.2-2.3-2.9-.1-6.2-8 6.5-.5 1.6h-5.6l-1.2 1z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M409.8 414.2l.6.8 2.7-.9 2 1.7 1.2 2.8-1 8.2.9 2.9 2.4-.1.7 1 1.8-.7 2.9 2.5 2.5.5 1.5-.9-.5-3-1.2-1 3.3-2.4 5.8-1.7 2.7-1.7-.4-2.8-1.3-.9-.5-3.7-1.3-2.1-2.3-1.3-1.7-5.1-4.7-2.1-1.6-2z"
}), React.createElement("path", {
  fill: "none",
  d: "M409.8 414.2l.6.8 2.7-.9 2 1.7 1.2 2.8-1 8.2.9 2.9 2.4-.1.7 1 1.8-.7 2.9 2.5 2.5.5 1.5-.9-.5-3-1.2-1 3.3-2.4 5.8-1.7 2.7-1.7-.4-2.8-1.3-.9-.5-3.7-1.3-2.1-2.3-1.3-1.7-5.1-4.7-2.1-1.6-2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M463.6 211.5l.1 25 27.4.1-4.5-5.1-1.8-1.4v-10.7l-1.8-1.8-1.1.5-1.9-1.6-4-1.8-2.5.3-3.1-2.3-.5-1.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M463.6 211.5l.1 25 27.4.1-4.5-5.1-1.8-1.4v-10.7l-1.8-1.8-1.1.5-1.9-1.6-4-1.8-2.5.3-3.1-2.3-.5-1.2z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M214.9 368.1l2.2 1 5.9-.4 1.4-2.1.2 2.5 3.6-1.3.3 1.9 1.5.2 1.7 2.2.6 2.5 2.1-.3.6.9-.5 2.8.9.7 1.3-3 .9 3.3-.9 1.5 3.8 1.1 1 1.9 4 .9 2.4 4.6 2.4 1 2.8 2 .5 1.4 3.5 1.9 2.2-.8.1-3.6 1.4-.6.5-4v-43.8H215z"
}), React.createElement("path", {
  fill: "none",
  d: "M214.9 368.1l2.2 1 5.9-.4 1.4-2.1.2 2.5 3.6-1.3.3 1.9 1.5.2 1.7 2.2.6 2.5 2.1-.3.6.9-.5 2.8.9.7 1.3-3 .9 3.3-.9 1.5 3.8 1.1 1 1.9 4 .9 2.4 4.6 2.4 1 2.8 2 .5 1.4 3.5 1.9 2.2-.8.1-3.6 1.4-.6.5-4v-43.8H215z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M287 376.1l.1 27 30.5-.3.1-26.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M287 376.1l.1 27 30.5-.3.1-26.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M190.5 272.9l.7 29 23 .3v-29.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M190.5 272.9l.7 29 23 .3v-29.3z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M504.1 225.4l.5 1.1 2.1-.4 2.3 1.3 2.9-.2 6.8-2.8 2.6-3.6 2.5.4-.1-11.8-.7-1.4-18.9.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M504.1 225.4l.5 1.1 2.1-.4 2.3 1.3 2.9-.2 6.8-2.8 2.6-3.6 2.5.4-.1-11.8-.7-1.4-18.9.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M530 303.3l-4.2 2.4 4.9 24.7h20.7l-1-2.5 1.7-4-1.5-1.6-1.6.1-.1-3.1-.9-2.3-1.3-.3-.6-3.5-1-1.8.7-1.5-2-2 .5-1.1-2.6-2.7-1.4 1.2-.8-1-3.1.6-1.6 1.2-.3-1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M530 303.3l-4.2 2.4 4.9 24.7h20.7l-1-2.5 1.7-4-1.5-1.6-1.6.1-.1-3.1-.9-2.3-1.3-.3-.6-3.5-1-1.8.7-1.5-2-2 .5-1.1-2.6-2.7-1.4 1.2-.8-1-3.1.6-1.6 1.2-.3-1.5z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M496.4 313.5l.7-2 2.6-.4 1 1v2.3l1.3.8 11.4-11.1 4.3-5.3-1.4-5.3-1-.4-.2-3.8-2.6-.9.1-1.9-20.9 16.8.1 6.2 2.3 2.9-.7 1.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M496.4 313.5l.7-2 2.6-.4 1 1v2.3l1.3.8 11.4-11.1 4.3-5.3-1.4-5.3-1-.4-.2-3.8-2.6-.9.1-1.9-20.9 16.8.1 6.2 2.3 2.9-.7 1.2z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M392.2 355.9l9.5-9.4 5.4-10.7-3.4-2.1-2.9-1.2-.7.5-2.1-1.3-7.4 2.6-.4.8-2.6-.7-1.5-1.3-.8-3.7-2.1-1.7-.1-1.3-1.7-1.2-1.5 1-2.6-.8-2.9 6.3.8 1.7-3.3 5.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M392.2 355.9l9.5-9.4 5.4-10.7-3.4-2.1-2.9-1.2-.7.5-2.1-1.3-7.4 2.6-.4.8-2.6-.7-1.5-1.3-.8-3.7-2.1-1.7-.1-1.3-1.7-1.2-1.5 1-2.6-.8-2.9 6.3.8 1.7-3.3 5.7z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M236.4 279.2l25.2.3.2 22.4 25.1-.1.2-25.2-5.4-.1-.1-5.7-25.8-.2-1.6-.5-.1 7.4-17.7.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M236.4 279.2l25.2.3.2 22.4 25.1-.1.2-25.2-5.4-.1-.1-5.7-25.8-.2-1.6-.5-.1 7.4-17.7.3z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M505.3 201.3h1l2.6-1.9 4.3-.3 3.6 3.6 1.9 1.2.5-19.9-3.6-1.6-1 .5-7.9-.6-1.4.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M505.3 201.3h1l2.6-1.9 4.3-.3 3.6 3.6 1.9 1.2.5-19.9-3.6-1.6-1 .5-7.9-.6-1.4.4z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M315.1 205.3h22.7l-.1-23-22.7-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M315.1 205.3h22.7l-.1-23-22.7-.1z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M178.3 205.2H201l.1-22.5h-22.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M178.3 205.2H201l.1-22.5h-22.7z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M190.3 363.2l5.6 2.1 3.4 2.3 2.9.3.5-.9 4.6.9 3.5-1.1 2.1 1.4 2-.1.1-25.6.7-1.7 3.6-1.7-3.6-3.4.7-2.5 1.1.7.9-3.2 1.4-1.5-.7-1.9.5-1.7-2.5-1.6-18.7-.2-.1 3-8.9-.1v16l-9.8.1v11.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M190.3 363.2l5.6 2.1 3.4 2.3 2.9.3.5-.9 4.6.9 3.5-1.1 2.1 1.4 2-.1.1-25.6.7-1.7 3.6-1.7-3.6-3.4.7-2.5 1.1.7.9-3.2 1.4-1.5-.7-1.9.5-1.7-2.5-1.6-18.7-.2-.1 3-8.9-.1v16l-9.8.1v11.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M285.3 250.7l22.8.1V228l-22.6-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M285.3 250.7l22.8.1V228l-22.6-.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M399.1 226.2l22.5.4.2-22.7-22.4-.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M399.1 226.2l22.5.4.2-22.7-22.4-.5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M204.5 110.9V134h23v-23.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M204.5 110.9V134h23v-23.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M249.9 342.5l36.9-.1v-21.3l-36.9.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M249.9 342.5l36.9-.1v-21.3l-36.9.2z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M285.6 205.1h6.8l-.1-22.8-23-.1-.1 22.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M285.6 205.1h6.8l-.1-22.8-23-.1-.1 22.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M255.8 270.6l.2-20.1h-19.4l-.2 27.3 17.7-.3.1-7.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M255.8 270.6l.2-20.1h-19.4l-.2 27.3 17.7-.3.1-7.4z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M354.2 228.3l.1-22.9-22.8-.1v23z"
}), React.createElement("path", {
  fill: "none",
  d: "M354.2 228.3l.1-22.9-22.8-.1v23z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M328.4 528.1v1.2l1.7.5 1.6 2.4-.9 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.8-1.1 1.4 1.9 3.1-.8 1.6 1.9h1.6l3.2 4 1.1.6 3-1 11.6-25.7-27.7-.1-2.5 5.4-6.9 5z"
}), React.createElement("path", {
  fill: "none",
  d: "M328.4 528.1v1.2l1.7.5 1.6 2.4-.9 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.8-1.1 1.4 1.9 3.1-.8 1.6 1.9h1.6l3.2 4 1.1.6 3-1 11.6-25.7-27.7-.1-2.5 5.4-6.9 5z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M381.8 242.9l3.6 7.5 10.2-6.2.7.2v-5.9l-7.3.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M381.8 242.9l3.6 7.5 10.2-6.2.7.2v-5.9l-7.3.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M491.1 236.6l.1 3.1-1.8 3.2 1.1 1.6-.6 2.9.8.6 20.7-.2v-20.7l-2.4.3-2.3-1.3-2.1.4-.5-1.1-1.3 1.6-1-1.7-1.4.6-4.1-2.3h-5.7l-5.8-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M491.1 236.6l.1 3.1-1.8 3.2 1.1 1.6-.6 2.9.8.6 20.7-.2v-20.7l-2.4.3-2.3-1.3-2.1.4-.5-1.1-1.3 1.6-1-1.7-1.4.6-4.1-2.3h-5.7l-5.8-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M197.3 40.7h23.6l-.1-24.1-23.5-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M197.3 40.7h23.6l-.1-24.1-23.5-.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M532.2 256.3v2.6l1.3 1.1 2.5 5.3.3 4.8.8 2.7 13.5 1.7 4.6 2.6 3.9-2.2 2.7 1.4.7-1.5-.1-3 1.1-1.5-1.8-2.5.6-1.2-2.3-2.5-.9-3.2-1.5-1.4-1.8-.4-1.9-3.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M532.2 256.3v2.6l1.3 1.1 2.5 5.3.3 4.8.8 2.7 13.5 1.7 4.6 2.6 3.9-2.2 2.7 1.4.7-1.5-.1-3 1.1-1.5-1.8-2.5.6-1.2-2.3-2.5-.9-3.2-1.5-1.4-1.8-.4-1.9-3.1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M308.9 205.3h22.6v23h-22.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M308.9 205.3h22.6v23h-22.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M263 227.8l.2-22.8-16.7-.4-5.9.4-.1 22.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M263 227.8l.2-22.8-16.7-.4-5.9.4-.1 22.6z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M249.9 321.3l36.9-.2.1-19.3-37.1.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M249.9 321.3l36.9-.2.1-19.3-37.1.3z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M337.2 310.3H360l1.3-1.1-1.4-.4-.5-2.9.8-1.1-1.9-1.9 1.2-2.1-1.9-.5-1.1 1.5-1-1.9 1.8-2.2-2.7-1.5.2-1.7-2.8-2.6 1.3-.3.5-1.8-2.5.4-.5-2.3-2.5.6.6-3.1h-1.8l-1.7 1.5.2-1.7-3.6-.1-.6-1.5-2.8.3-2.6-1.4.1-1-1.2.8-1-1.1-2.2 1.5v27.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.2 310.3H360l1.3-1.1-1.4-.4-.5-2.9.8-1.1-1.9-1.9 1.2-2.1-1.9-.5-1.1 1.5-1-1.9 1.8-2.2-2.7-1.5.2-1.7-2.8-2.6 1.3-.3.5-1.8-2.5.4-.5-2.3-2.5.6.6-3.1h-1.8l-1.7 1.5.2-1.7-3.6-.1-.6-1.5-2.8.3-2.6-1.4.1-1-1.2.8-1-1.1-2.2 1.5v27.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M384.6 454.4l.6.8 3 .1-.4 4.8 5.2 1.2.7 1.7 1.6.9 1.3-1.3.8 1.7 2.7.5 8.6-1.4-1 1.2 4.6-1.3 1.6 2.8 3.4-4.2-7.9-11.5-1.2.8-3.7.2.3-1.3-2.1-.6-.2-1.1-2.1 1.3-.8-.7-1.2 1.8-11-2.4-3.7 3.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M384.6 454.4l.6.8 3 .1-.4 4.8 5.2 1.2.7 1.7 1.6.9 1.3-1.3.8 1.7 2.7.5 8.6-1.4-1 1.2 4.6-1.3 1.6 2.8 3.4-4.2-7.9-11.5-1.2.8-3.7.2.3-1.3-2.1-.6-.2-1.1-2.1 1.3-.8-.7-1.2 1.8-11-2.4-3.7 3.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M503.5 339.6l14.2-7.2-1.1-1.2 1.6-1.6-4.8-.9-1.1-.8-2.8-.1.9-1.4-2-3.8-2.2 1.1-.2-1.7-1.1-.1-.5-2.6.6-1.9-4.3-3v-2.3l-1-1-2.6.4-.7 2-1.3 18 2.2 5.1 3.2 1.3 1.4 1.4-1 1.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M503.5 339.6l14.2-7.2-1.1-1.2 1.6-1.6-4.8-.9-1.1-.8-2.8-.1.9-1.4-2-3.8-2.2 1.1-.2-1.7-1.1-.1-.5-2.6.6-1.9-4.3-3v-2.3l-1-1-2.6.4-.7 2-1.3 18 2.2 5.1 3.2 1.3 1.4 1.4-1 1.6z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M537.1 272.8l3.8 3.3.5 3.2-.9 4.2.7 1.2-1.1 3.2.6 2.8-1 2.1.6 2 2.8 2.3 1.6.2 1.4 2 2.8 1.9 3.5-.8.9-6.4-.8-2.8 1.1-3.5-1-2.4 2.7-2.9-.1-5.3-4.6-2.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M537.1 272.8l3.8 3.3.5 3.2-.9 4.2.7 1.2-1.1 3.2.6 2.8-1 2.1.6 2 2.8 2.3 1.6.2 1.4 2 2.8 1.9 3.5-.8.9-6.4-.8-2.8 1.1-3.5-1-2.4 2.7-2.9-.1-5.3-4.6-2.6z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M558.4 298.2l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.7-1.3-.6.5-1.4-2.5-1.6 1.6-2.3-3.1-.6-2.2-3.1-2.7-1.4-3.9 2.2.1 5.3-2.7 2.9 1 2.4-1.1 3.5.8 2.8-.9 4.9.4.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M558.4 298.2l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.7-1.3-.6.5-1.4-2.5-1.6 1.6-2.3-3.1-.6-2.2-3.1-2.7-1.4-3.9 2.2.1 5.3-2.7 2.9 1 2.4-1.1 3.5.8 2.8-.9 4.9.4.5z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M511.4 235.8v27.1l23.4.1-1.3-3-1.3-1.1v-2.6h-3.9l-.1-5.5 1-6.2 2.1-3.7 1.7-4.4v-1.9l-2.8-.7-1 .7-.9 1.7-1.7-.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M511.4 235.8v27.1l23.4.1-1.3-3-1.3-1.1v-2.6h-3.9l-.1-5.5 1-6.2 2.1-3.7 1.7-4.4v-1.9l-2.8-.7-1 .7-.9 1.7-1.7-.5z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M287.1 276.6l17 .1.3-26h-22.8l.1 25.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M287.1 276.6l17 .1.3-26h-22.8l.1 25.8z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M444.3 212.8l9.7-.1V204h-9.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M444.3 212.8l9.7-.1V204h-9.6z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M430.7 300.9l3.6 5.7-1 1.1.6 2.3 1.3 1.5 1.2-.6.2 2.3 2.3 2.4-.1 2 1.4 1-.4 1.4 2.4 1.8 4.8-2.5 3.1-6.1 2.2-2.9 4.2-2.7-.9-2.1.8-2.3-1.7-1.7-.7-4.5-1.5-3.6.5-5.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M430.7 300.9l3.6 5.7-1 1.1.6 2.3 1.3 1.5 1.2-.6.2 2.3 2.3 2.4-.1 2 1.4 1-.4 1.4 2.4 1.8 4.8-2.5 3.1-6.1 2.2-2.9 4.2-2.7-.9-2.1.8-2.3-1.7-1.7-.7-4.5-1.5-3.6.5-5.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M244.4 63.9v.3h23.9V40.6h-23.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M244.4 63.9v.3h23.9V40.6h-23.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M411.8 453.4l.9.7 8.9-6.9-2.8-1.3-1-2.2 14.6-2.4-3-4.8 3.3.8-.1-2.3-.9.7-3.7-3.7-1.5.9-2.5-.5-2.9-2.5-1.8.7-.7-1-2.4.1-9.4 8.2-7.2 11.1.8.7 2.1-1.3.2 1.1 2.1.6-.3 1.3 3.7-.2 1.2-.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M411.8 453.4l.9.7 8.9-6.9-2.8-1.3-1-2.2 14.6-2.4-3-4.8 3.3.8-.1-2.3-.9.7-3.7-3.7-1.5.9-2.5-.5-2.9-2.5-1.8.7-.7-1-2.4.1-9.4 8.2-7.2 11.1.8.7 2.1-1.3.2 1.1 2.1.6-.3 1.3 3.7-.2 1.2-.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M135 318.2l25.1-30.9-1.8-.7-.5 1-5.1-.3-2.8-.9-.7-2-3.3.7-2.5-.9-2.3.4-1.9-1.7-.7-3v-4.4l-1.1-2.1-1.4.5-2.1-1-.6-2.7-2-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-1.9 1.1-3-6.2-1.2-.6h-1.9l-3.4 45.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M135 318.2l25.1-30.9-1.8-.7-.5 1-5.1-.3-2.8-.9-.7-2-3.3.7-2.5-.9-2.3.4-1.9-1.7-.7-3v-4.4l-1.1-2.1-1.4.5-2.1-1-.6-2.7-2-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-1.9 1.1-3-6.2-1.2-.6h-1.9l-3.4 45.9z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M497.3 183.1l2.3.7 7.1-1.5 7.9.6 1-.5 3.6 1.6 1.4 2.4 1.3-.5v-19.7l-1.1-3-1.4 1.5-.9-2-1.1 1.6-2.7-2.1-.6-1.5-1.3-.5-.7-2.3-3.5-.2-.4-2-1 1.2-1.6-1.3-.5-1.7H504l-2.8-1.3-2.3 2.6-.5 1.9-1.2-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M497.3 183.1l2.3.7 7.1-1.5 7.9.6 1-.5 3.6 1.6 1.4 2.4 1.3-.5v-19.7l-1.1-3-1.4 1.5-.9-2-1.1 1.6-2.7-2-.6-1.6-1.3-.5-.7-2.3-3.5-.2-.4-2-1 1.2-1.6-1.3-.5-1.7H504l-2.8-1.3-2.3 2.6-.5 1.9-1.2-.1z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M291.3 376.1l18-.2.1-14.1-4-.1.1-8.3h-10l-2.2-.5-.2 3-.7-.1-.6 6.5-1.4 2.7 1 2.4-1.1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M291.3 376.1l18-.2.1-14.1-4-.1.1-8.3h-10l-2.2-.5-.2 3-.7-.1-.6 6.5-1.4 2.7 1 2.4-1.1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M214.2 302.2h21.9l.4-29.3h-22.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M214.2 302.2h21.9l.4-29.3h-22.3z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M197 111l23.6-.1.3-23.2h-23.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M197 111l23.6-.1.3-23.2h-23.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M469.9 211.5l.5 1.2 3.1 2.3 2.5-.3 4 1.8 1.9 1.6 1.1-.5-1.4-13.5h-12.2l-1.8 5.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M469.9 211.5l.5 1.2 3.1 2.3 2.5-.3 4 1.8 1.9 1.6 1.1-.5-1.4-13.5h-12.2l-1.8 5.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M78.8 332.9l.4 4.4 1.9.8-.3 1.3 2.2 2.4.4 1.4 2.5 2 .9 2.8-.4 2.3.3 3.1-.8 1.2 1.4 4.7-.3 1.1 5.1 8.2.9 4.6 3.4 3.6 2.9 1.8 2.7 2.7 3.3.3 2.4 1.7-.4 1.2 2.4 3.2 2.5 1 3.8 3 9.9 2.5-.3-58h-4.4l-47.3-11 .4 1 2.3.6 1.6 3.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M78.8 332.9l.4 4.4 1.9.8-.3 1.3 2.2 2.4.4 1.4 2.5 2 .9 2.8-.4 2.3.3 3.1-.8 1.2 1.4 4.7-.3 1.1 5.1 8.2.9 4.6 3.4 3.6 2.9 1.8 2.7 2.7 3.3.3 2.4 1.7-.4 1.2 2.4 3.2 2.5 1 3.8 3 9.9 2.5-.3-58h-4.4l-47.3-11 .4 1 2.3.6 1.6 3.3z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M220.9 87.7V64.2h-23.6l-.2 23.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M220.9 87.7V64.2h-23.6l-.2 23.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M502 315.2l3 2.2-.6 1.9.5 2.6 1.1.1.2 1.7 2.2-1.1 2 3.8-.9 1.4 2.8.1 1.1.8 4.8.9-1.6 1.6.8.9 13.6.1-5.2-26.5 4.2-2.4-2.3-1.4-5.5-.9-4.5-2.2-4.3 5.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M502 315.2l3 2.2-.6 1.9.5 2.6 1.1.1.2 1.7 2.2-1.1 2 3.8-.9 1.4 2.8.1 1.1.8 4.8.9-1.6 1.6.8.9 13.6.1-5.2-26.5 4.2-2.4-2.3-1.4-5.5-.9-4.5-2.2-4.3 5.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M135 318.2l44.6 36.2v-11.6l9.8-.1v-16l8.9.1.1-3 16.1.2-1.8-2.5-.3-2.5-1.9-6.3-1.3-.8.7-1.1-5.2-4-1.7-.4-2.1.6-2.6-.4-2.8-1.9-3.3-.1-2.2-1.8-2.6-1-1.8-1.9v-3.3l-1.2-1.7-2.8-2.1-2.5-.4-4.3-2.8-6.5 3-4.8-4.2-3.4-1.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M135 318.2l44.6 36.2v-11.6l9.8-.1v-16l8.9.1.1-3 16.1.2-1.8-2.5-.3-2.5-1.9-6.3-1.3-.8.7-1.1-5.2-4-1.7-.4-2.1.6-2.6-.4-2.8-1.9-3.3-.1-2.2-1.8-2.6-1-1.8-1.9v-3.3l-1.2-1.7-2.8-2.1-2.5-.4-4.3-2.8-6.5 3-4.8-4.2-3.4-1.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M158.7 134h22.7v-23l-22.7-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M158.7 134h22.7v-23l-22.7-.1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M376.5 226l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M376.5 226l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M553.9 256l-1.2-1v-20.3l-13.4 3.2-1.6-1.9-2.4.2-2.3-1.6v1.9l-1.7 4.4-2.1 3.7-1 6.2.1 5.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M553.9 256l-1.2-1v-20.3l-13.4 3.2-1.6-1.9-2.4.2-2.3-1.6v1.9l-1.7 4.4-2.1 3.7-1 6.2.1 5.5z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M358.7 228.4l17.8.1.5-25.6-16.2-.3v2.9l-6.5-.1-.1 22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M358.7 228.4l17.8.1.5-25.6-16.2-.3v2.9l-6.5-.1-.1 22.9z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M549.4 344.9l1 1.9-.9 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.2.8 1.2 1 2.6.6 5.1-1.8 1.4-1.8 1-.5-1.5-1.1 1.8-2.6-1.2-3.9.6-1.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M549.4 344.9l1 1.9-.9 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.2.8 1.2 1 2.6.6 5.1-1.8 1.4-1.8 1-.5-1.5-1.1 1.8-2.6-1.2-3.9.6-1.6z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M158.8 87.7h38.3l.2-23.9-38.5.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M158.8 87.7h38.3l.2-23.9-38.5.3z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M244.4 40.6H268v-24h-23.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M244.4 40.6H268v-24h-23.6z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M412.4 477.9l1.1.2 3.2-6.2 4.6-6.5-2.1 1.1-4.6 6.4z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M382 475.2l2.4.8 2 3 22.6-.1 3.5-6.5-5.1-2.1-.9-5.1-9.1-.9-.8-1.7-1.3 1.3-1.6-.9-.7-1.7-5.2-1.2.5-2.7-6 5.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M412.4 477.9l1.1.2 3.2-6.2 4.6-6.5-2.1 1.1-4.6 6.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M382 475.2l2.4.8 2 3 22.6-.1 3.5-6.5-5.1-2.1-.9-5.1-9.1-.9-.8-1.7-1.3 1.3-1.6-.9-.7-1.7-5.2-1.2.5-2.7-6 5.5z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M262.8 250.5l22.5.2.2-22.8-22.5-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M262.8 250.5l22.5.2.2-22.8-22.5-.1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M558.9 344.8h8.5l.1-2.4-1.7-.5-.8-2.7.9-2.5 1.9-2.1-1.6-4.5.3-2.1 2.1-1.3-.2-2.1 2.3-1.9 1-1.9-.3-2.1 2.7-4-.2-4 1.4-.8-.3-1.5-1.6-.5.6-1.8 2-1.3-.8-2.3-1.5-1.2 1-.9-.6-3.6-15.7 1.4 2 10.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M558.9 344.8h8.5l.1-2.4-1.7-.5-.8-2.7.9-2.5 1.9-2.1-1.6-4.5.3-2.1 2.1-1.3-.2-2.1 2.3-1.9 1-1.9-.3-2.1 2.7-4-.2-4 1.4-.8-.3-1.5-1.6-.5.6-1.8 2-1.3-.8-2.3-1.5-1.2 1-.9-.6-3.6-15.7 1.4 2 10.8z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M435.5 264.5l9.8 1 19.3-11.2-.5-3.8-1.7.6-.5-1 .6-2.9-2.8-.4.5-3-1.6.6-1.9-2.4-2.2-.2-.1-2-4.2-1.9-22.4 13.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M435.5 264.5l9.8 1 19.3-11.2-.5-3.8-1.7.6-.5-1 .6-2.9-2.8-.4.5-3-1.6.6-1.9-2.4-2.2-.2-.1-2-4.2-1.8-22.4 13.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M516.7 279.3l1.8 2.2.7-.3 5.3 2 5.8.8.7 1.9 1.6-.6 2.3 4.6 2.3.9.6 1.5 2.5 2.5-.6-2 1-2.1-.6-2.8 1.1-3.2-.7-1.2.9-4.2-.5-3.2-3.8-3.3-.8-2.7-.3-4.8-1.2-2.3-21.3-.1-1.6 3.3 2.1 1-1.7.5v3l1.8 5.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M516.7 279.3l1.8 2.2.7-.3 5.3 2 5.8.8.7 1.9 1.6-.6 2.3 4.6 2.3.9.6 1.5 2.5 2.5-.6-2 1-2.1-.6-2.8 1.1-3.2-.7-1.2.9-4.2-.5-3.2-3.8-3.3-.8-2.7-.3-4.8-1.2-2.3-21.3-.1-1.6 3.3 2.1 1-1.7.5v3l1.8 5.9z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M246.3 134l.1 25.3 22.8-.1.1-25.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M246.3 134l.1 25.3 22.8-.1.1-25.2z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M523 208l.7 1.4 2.2-.1.1-20.3-1.7-2.3-1.7.2-.7-1-1.3.5-1.4-2.4-.5 19.9 2.1 2.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M523 208l.7 1.4 2.2-.1.1-20.3-1.7-2.3-1.7.2-.7-1-1.3.5-1.4-2.4-.5 19.9 2.1 2.9z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M197.3 40.7v23.5h23.6V40.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M197.3 40.7v23.5h23.6V40.7z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M475.6 344.7v7.8l1.8.2 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.3 1.1 2.1 2.2-.7.6 1.2 2.7.9 1.6 2 2.2.1 7.2-6.8-3-9-2.6 1.3 1-1.6-1.4-1.4-3.2-1.3-2.4-5.3h-10.3l-10.2-6.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M475.6 344.7v7.8l1.8.2 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.3 1.1 2.1 2.2-.7.6 1.2 2.7.9 1.6 2 2.2.1 7.2-6.8-3-9-2.6 1.3 1-1.6-1.4-1.4-3.2-1.3-2.4-5.3h-10.3l-10.2-6.2z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M383 180.4h18.9l.1-25.4-3.3.9-1.3-.3.1-2.5-3.2-2-1.2.1-1.9 2.7-1.4.1-3.1 4.1-1.6.4-4.7-2.1v24z"
}), React.createElement("path", {
  fill: "none",
  d: "M383 180.4h18.9l.1-25.4-3.3.9-1.3-.3.1-2.5-3.2-2-1.2.1-1.9 2.7-1.4.1-3.1 4.1-1.6.4-4.7-2.1v24z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M256 250.5h6.8l.2-22.7-22.5-.2-.4 22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M256 250.5h6.8l.2-22.7-22.5-.2-.4 22.9z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M336.1 281.5l-.1 1 2.6 1.4 2.8-.3.6 1.5 3.6.1-.2 1.7 1.7-1.5h1.8l-.6 3.1 2.5-.6.5 2.3 2.5-.4-.5 1.8-1.3.3 2.8 2.6 13-9.2-9.9-16.1-11.7 1.8-.9 4z"
}), React.createElement("path", {
  fill: "none",
  d: "M336.1 281.5l-.1 1 2.6 1.4 2.8-.3.6 1.5 3.6.1-.2 1.7 1.7-1.5h1.8l-.6 3.1 2.5-.6.5 2.3 2.5-.4-.5 1.8-1.3.3 2.8 2.6 13-9.2-9.9-16.1-11.7 1.8-.9 4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M409.4 318.9l2 .9 5 14.1 23.4-13.9.4-1.4-1.4-1 .1-2-2.3-2.4-.2-2.3-1.2.6-1.3-1.5-.6-2.3 1-1.1-3.6-6-18.8 11.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M409.4 318.9l2 .9 5 14.1 23.4-13.9.4-1.4-1.4-1 .1-2-2.3-2.4-.2-2.3-1.2.6-1.3-1.5-.6-2.3 1-1.1-3.6-6-18.8 11.3z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M214.2 272.9v-22.4h-22.4v22.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M214.2 272.9v-22.4h-22.4v22.4z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M314.5 321v-11.7h-5.2v-7.5h-22.4l-.1 19.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M314.5 321v-11.7h-5.2v-7.5h-22.4l-.1 19.3z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M344.2 402.9v-30.2l-5.3 6.5-2.6-.1.1-3-18.7-.2-.1 26.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M344.2 402.9v-30.2l-5.3 6.5-2.6-.1.1-3-18.7-.2-.1 26.9z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M344.3 454.3h20.5V425h-20.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M344.3 454.3h20.5V425h-20.4z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M396.7 276.2l8.2 13.7 3.3 3.9 23.7-14.3-10.3-17.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M396.7 276.2l8.2 13.7 3.3 3.9 23.7-14.3-10.3-17.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M314.5 309.3h17.2v-26.6l-4.9-.3-1.6-.8-3.3 3.7-5.9-3.1.5 1.3-3.3 1.1-1-3.1-2.8-.4-.1 28.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M314.5 309.3h17.2v-26.6l-4.9-.3-1.6-.8-3.3 3.7-5.9-3.1.5 1.3-3.3 1.1-1-3.1-2.8-.4-.1 28.2z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M263.5 410.3l2.5 2.6 1 3.2h1l.6 3.2 1.1 1.1.3 3.9 2.4 1-.1 1.6 2.2 1.2-.5 1.5 1 2.1 2.3.6-1.5 1.1 1.4 2.4-.6 1.5 2.7 4.2-.2 1.9 1.5 1.9 1.5.2.5 1.9h4.4l.1-44.3-24.4.1 1 4.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M263.5 410.3l2.5 2.6 1 3.2h1l.6 3.2 1.1 1.1.3 3.9 2.4 1-.1 1.6 2.2 1.2-.5 1.5 1 2.1 2.3.6-1.5 1.1 1.4 2.4-.6 1.5 2.7 4.2-.2 1.9 1.5 1.9 1.5.2.5 1.9h4.4l.1-44.3-24.4.1 1 4.9z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M481.3 419.9h.9l6.4-3.8-2.7-.2-1-2-2.2-1.7-.2-1.7-1.3-1.3-3.9-.2-.9-3.6.8-.7-3.5-2.7.1-4.9-1.3-1.2-4 4.1-15 9.2-.6 16.1 5-2.8-1.2 2.7 3.6 1.5 5-2 2.1 2.6-6.8 2.9-8.3 5.2 16.4-8.8 1.7-4.3 6-2.3 4.7-.1-10.4 5.5 5.8-2z"
}), React.createElement("path", {
  fill: "none",
  d: "M481.3 419.9h.9l6.4-3.8-2.7-.2-1-2-2.2-1.7-.2-1.7-1.3-1.3-3.9-.2-.9-3.6.8-.7-3.5-2.7.1-4.9-1.3-1.2-4 4.1-15 9.2-.6 16.1 5-2.8-1.2 2.7 3.6 1.5 5-2 2.1 2.6-6.8 2.9-8.3 5.2 16.4-8.8 1.7-4.3 6-2.3 4.7-.1-10.4 5.5 5.8-2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M314.5 309.3v22.5h22.8l-.1-21.5h-5.5v-1z"
}), React.createElement("path", {
  fill: "none",
  d: "M314.5 309.3v22.5h22.8l-.1-21.5h-5.5v-1z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M195.1 250.5l22.6-.1.3-22.6-22.9.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M195.1 250.5l22.6-.1.3-22.6-22.9.1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M523.8 213.8l8.5 5.2h5.5l3.7-1.5 1-1.4 1.4-.1.9 2.5 2 .5 1.5-2.5 1.8.2.5 2.5 2.1-.1v-9.8l-29 .1z"
}), React.createElement("path", {
  fill: "none",
  d: "M523.8 213.8l8.5 5.2h5.5l3.7-1.5 1-1.4 1.4-.1.9 2.5 2 .5 1.5-2.5 1.8.2.5 2.5 2.1-.1v-9.8l-29 .1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M459.6 315.3l13.4-2.1 3.4-.8 1.2-1h5.6l.5-1.6-.9.2-1.8-3 2-2.6-1.3-2.4-2.6.2-1.8-.7-9.1.1-3.3 1.2-5.4 3.8-3 1 1.4 1.4-.2 1.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M459.6 315.3l13.4-2.1 3.4-.8 1.2-1h5.6l.5-1.6-.9.2-1.8-3 2-2.6-1.3-2.4-2.6.2-1.8-.7-9.1.1-3.3 1.2-5.4 3.8-3 1 1.4 1.4-.2 1.8z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M201 205.2l22.8-.1v-22.7l-22.7.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M201 205.2l22.8-.1v-22.7l-22.7.3z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M201.1 182.7l22.7-.3-.3-22.9-22.9.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M201.1 182.7l22.7-.3-.3-22.9-22.9.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M133.9 272.9h12.4v-18l-28.6.1 1.2.6 3 6.2 1.9-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 2 .6z"
}), React.createElement("path", {
  fill: "none",
  d: "M133.9 272.9h12.4v-18l-28.6.1 1.2.6 3 6.2 1.9-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 2 .6z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M337.3 331.8l24.2-.1 2.7.8v-3.7l-2.2-.3v-1.7l-1.7-3.9 1.5-.1-.5-1.3 1.8-2.3-2.4-.3-.1-1.6 2.3-2.6H361l-.2-1.6-1.4-.6.6-2.2h-22.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.3 331.8l24.2-.1 2.7.8v-3.7l-2.2-.3v-1.7l-1.7-3.9 1.5-.1-.5-1.3 1.8-2.3-2.4-.3-.1-1.6 2.3-2.6H361l-.2-1.6-1.4-.6.6-2.2h-22.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M364.8 454.3l19.8.1-.9-2.9 4.1-3.4-12.3-23.9 3.7-1.3-4-4.9-10.4 8.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M364.8 454.3l19.8.1-.9-2.9 4.1-3.4-12.3-23.9 3.7-1.3-4-4.9-10.4 8.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M268.3 40.6l23.6.1V16.6H268z"
}), React.createElement("path", {
  fill: "none",
  d: "M268.3 40.6l23.6.1V16.6H268z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M431.9 279.5l9 15.5 12.1-7-.1-.8 3.8-2.1-11.4-19.6-9.8-1-9.3 5.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M431.9 279.5l9 15.5 12.1-7-.1-.8 3.8-2.1-11.4-19.6-9.8-1-9.3 5.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M503.5 339.6l5.9 17.8 1.4.1.9 1.8-.9 1.8.9 1.8 23.5-.2-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M503.5 339.6l5.9 17.8 1.4.1.9 1.8-.9 1.8.9 1.8 23.5-.2-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M453 288l-.5 5.4 1.5 3.6.7 4.5 1.7 1.7-.8 2.3.9 2.1 3-1 5.4-3.8 3.3-1.2 9.1-.1-.4-2.3 2-1.2-.8-2.4.9-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4.1-1.5-.1.3-2.4-.6-2.5 1.6-.1-.5-1.5.8-1.7-1.1-1.9-1.4 2.9-.9-1.1-23.4 12.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M453 288l-.5 5.4 1.5 3.6.7 4.5 1.7 1.7-.8 2.3.9 2.1 3-1 5.4-3.8 3.3-1.2 9.1-.1-.4-2.3 2-1.2-.8-2.4.9-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4.1-1.5-.1.3-2.4-.6-2.5 1.6-.1-.5-1.5.8-1.7-1.1-1.9-1.4 2.9-.9-1.1-23.4 12.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M422.2 354.5l.2 1 7.6-4.3 4.5-4.1v-1.5l2.5-1.4 2-2.1-2.4-1.2-2 .1-1.3-2.4-2.4-2.6-2-1-2.1-5.2-2-.9-8.4 5-7.8 2.8 5.9 3.3 5.2 4z"
}), React.createElement("path", {
  fill: "none",
  d: "M422.2 354.5l.2 1 7.6-4.3 4.5-4.1v-1.5l2.5-1.4 2-2.1-2.4-1.2-2 .1-1.3-2.4-2.4-2.6-2-1-2.1-5.2-2-.9-8.4 5-7.8 2.8 5.9 3.3 5.2 4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M412.7 388.1l13.2 16.1 16.6-13.6-10.2-12.2h-1.7l-.5-1.9-1.4-.9-11.7.3-2.7 2.3.1 3.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M412.7 388.1l13.2 16.1 16.6-13.6-10.2-12.2h-1.7l-.5-1.9-1.4-.9-11.7.3-2.7 2.3.1 3.7z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M360.2 304.8l23.1-.3.2-1.8-11.9-20.1-4 2.4.2.3-13 9.2-.2 1.7 2.7 1.5-1.8 2.2 1 1.9 1.1-1.5 1.9.5-1.2 2.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M360.2 304.8l23.1-.3.2-1.8-11.9-20.1-4 2.4.2.3-13 9.2-.2 1.7 2.7 1.5-1.8 2.2 1 1.9 1.1-1.5 1.9.5-1.2 2.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M200.6 159.8l-.2-25.8h-22.9l-.1 25.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M200.6 159.8l-.2-25.8h-22.9l-.1 25.8z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M497.3 183.1l-.1-26.1-5.6.6-.9-1.1-3.7.4-.6-2.7-1.8-.6-1.3 1.8-1.8.1-1.1 1-2.7-.2-.5 2.3-1.6-.8-1.7 1.3-.5.5-.2 19.3 1.4.1 3-1.9 3.4 1.3 1.6-.8 3.6.6 1.5 1.5 1.5-.5 5.3 3.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M497.3 183.1l-.1-26.1-5.6.6-.9-1.1-3.7.4-.6-2.7-1.8-.6-1.3 1.8-1.8.1-1.1 1-2.7-.2-.5 2.3-1.6-.8-1.7 1.3-.5.5-.2 19.3 1.4.1 3-1.9 3.4 1.3 1.6-.8 3.6.6 1.5 1.5 1.5-.5 5.3 3.4z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M318.4 447l.3 8.7 25.6-1.4.1-29.3-26 .3z"
}), React.createElement("path", {
  fill: "none",
  d: "M318.4 447l.3 8.7 25.6-1.4.1-29.3-26 .3z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M292.3 182.3l22.7-.1-.1-17.6-.8-1.8-2.7-1.6-2 .6-1.4-1.5-2.7-.6-.2 1.3H303l-.4-1.1-3.3.3-.2-1h-7z"
}), React.createElement("path", {
  fill: "none",
  d: "M292.3 182.3l22.7-.1-.1-17.6-.8-1.8-2.7-1.6-2 .6-1.4-1.5-2.7-.6-.2 1.3H303l-.4-1.1-3.3.3-.2-1h-7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M407 492.9h1l5.5-14.8-1.1-.2-3.6 7.2z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M376.9 493.7h3.2v2.6l1.5-1.3 4.8-.5 2-1.4 5.9-.7-3.2-6.4 4.2 5.7 4.6-1.9 2.6-3.1-1.2 5.5 3.9-1.5 3.8-11.8-22.6.1-2-3-2.4-.8h-5.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M407 492.9h1l5.5-14.8-1.1-.2-3.6 7.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M376.9 493.7h3.2v2.6l1.5-1.3 4.8-.5 2-1.4 5.9-.7-3.2-6.4 4.2 5.7 4.6-1.9 2.6-3.1-1.2 5.5 3.9-1.5 3.8-11.8-22.6.1-2-3-2.4-.8h-5.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M262.7 403.2l24.4-.1-.1-27h-25.7v10.2l-.5 4-1.4.6-.1 3.6-2.2.8 1.3 2.7-.4.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M262.7 403.2l24.4-.1-.1-27h-25.7v10.2l-.5 4-1.4.6-.1 3.6-2.2.8 1.3 2.7-.4.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M269.3 182.2l23 .1-.2-23.1h-22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M269.3 182.2l23 .1-.2-23.1h-22.9z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M302.7 342.4l19.8.2-.1-10.8h-7.9V321l-27.7.1v21.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M302.7 342.4l19.8.2-.1-10.8h-7.9V321l-27.7.1v21.3z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M309.4 361.8l18.6.6 11.3 5.7-.1-18-16.7.2v-7.7l-19.8-.2-.2 10.9 3 .1-.1 8.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M309.4 361.8l18.6.6 11.3 5.7-.1-18-16.7.2v-7.7l-19.8-.2-.2 10.9 3 .1-.1 8.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M246.5 204.6l22.7.4.1-22.8-22.8.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M246.5 204.6l22.7.4.1-22.8-22.8.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M410.4 526.1l-3.4-15-.4-6.5 1.4-11.7h-.8l-1.1 7.5v9.2l3.6 15.1-.7 1.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M380.1 517.3v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.4.1-7.8h3.6l-1.2-4.3 2.4-1.7.1-7-3.7 1.9-5.4-2.4h-6.1l-2 1.4-4.8.5-1.5 1.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M410.4 526.1l-3.4-15-.4-6.5 1.4-11.7h-.8l-1.1 7.5v9.2l3.6 15.1-.7 1.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M380.1 517.3v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.3.1-7.9h3.6l-1.2-4.3 2.4-1.7.1-7-3.7 1.9-5.4-2.4h-6.1l-2 1.4-4.8.5-1.5 1.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M339.3 368.1l6.1 3.1 5.8-1.2 10.1-9.8-7.6-10.1h-14.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M339.3 368.1l6.1 3.1 5.8-1.2 10.1-9.8-7.6-10.1h-14.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M443.8 226.7l1.2 1-.3 2.3 1.4 2.5 1.9 1.2-.8 2.7 16.5.1-.1-25-9.6-.2v1.4l-9.7.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M443.8 226.7l1.2 1-.3 2.3 1.4 2.5 1.9 1.2-.8 2.7 16.5.1-.1-25-9.6-.2v1.4l-9.7.1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M375.2 418l4 4.9 3.8-1.5 4.1 2.5 2.1.1 8.9-7.3-7.9-9.7 6.2-5.1-5-5.6-20.3 17z"
}), React.createElement("path", {
  fill: "none",
  d: "M375.2 418l4 4.9 3.8-1.5 4.1 2.5 2.1.1 8.9-7.3-7.9-9.7 6.2-5.1-5-5.6-20.3 17z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M308.1 228.3h.8v-23l-23.3-.2-.1 22.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M308.1 228.3h.8v-23l-23.3-.2-.1 22.8z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M396.3 238.5v5.9l2.1 1.4-.1 1.4 2.3.9.2-1.5 1.6-.6v-.4l17.1-4.4-.1-14.7-23.2-.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M396.3 238.5v5.9l2.1 1.4-.1 1.4 2.3.9.2-1.5 1.6-.6v-.4l17.1-4.4-.1-14.7-23.2-.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M369.3 493.6l7.6.1v-18.5h5.1l.3-12.3 6-5.5-.1-2.1-3-.1-.6-.8-15.4-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M369.3 493.6l7.6.1v-18.5h5.1l.3-12.3 6-5.5-.1-2.1-3-.1-.6-.8-15.4-.1z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M337.7 517.1l23.3.1.2-13.4-2.2.1v-4.3h-1.1V495l-1.4-1.5.1-3.8-4.5-.8-7.6.2v4.3l-6.8-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.7 517.1l23.3.1.2-13.4-2.2.1v-4.3h-1.1V495l-1.4-1.5.1-3.8-4.5-.8-7.6.2v4.3l-6.8-.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M535.2 362.7l3.7.1.1 16.4 14.9-5.9h7.8l-4.8-5.1-.2-3.5 3.6-4.5-.1-2.1-2.6-.6-1.2-1-3.2-.8V354l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.9-.1-.7 2.5-4.6 1.1-2-.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M535.2 362.7l3.7.1.1 16.4 14.9-5.9h7.8l-4.8-5.1-.2-3.5 3.6-4.5-.1-2.1-2.6-.6-1.2-1-3.2-.8V354l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.9-.1-.7 2.5-4.6 1.1-2-.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M73.9 325.2l47.3 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M73.9 325.2l47.3 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M551.4 330.4l-1.9 4.7-.1 1.9 1.5 2.4-1.6 3.3 1 1.3-.9.9 9.5-.1 1.5-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.5 1.6-1.2 3.1-.6.8 1 1.4-1.2 2.6 2.7-.5 1.1 2 2-.7 1.5 1 1.8.6 3.5 1.3.3.9 2.3.1 3.1 1.6-.1 1.5 1.6-1.7 4z"
}), React.createElement("path", {
  fill: "none",
  d: "M551.4 330.4l-1.9 4.7-.1 1.9 1.5 2.4-1.6 3.4 1 1.2-.9.9 9.5-.1 1.5-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.5 1.6-1.2 3.1-.6.8 1 1.4-1.2 2.6 2.7-.5 1.1 2 2-.7 1.5 1 1.8.6 3.5 1.3.3.9 2.3.1 3.1 1.6-.1 1.5 1.6-1.7 4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M438.1 421.3l3.8.8 6.4-.1 1.6 1.6h3l.6-14.4-15.3-15-12.3 10 4.7 2.1 1.7 5.1 2.3 1.3 1.3 2.1.5 3.7 1.3.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M438.1 421.3l3.8.8 6.4-.1 1.6 1.6h3l.6-14.4-15.3-15-12.3 10 4.7 2.1 1.7 5.1 2.3 1.3 1.3 2.1.5 3.7 1.3.9z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M377 202.9l5.9.1.1-22.6h-2.6v-1.8H361l-.2 24z"
}), React.createElement("path", {
  fill: "none",
  d: "M377 202.9l5.9.1.1-22.6h-2.6v-1.8H361l-.2 24z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M249.8 302.1l12-.2-.2-22.4-25.2-.3-.3 23z"
}), React.createElement("path", {
  fill: "none",
  d: "M249.8 302.1l12-.2-.2-22.4-25.2-.3-.3 23z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M220.9 64l23.5-.1V40.7h-23.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M220.9 64l23.5-.1V40.7h-23.5z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M463.6 211.5h6.3l-2.3-2 1.8-5.4h3.6l.2-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M463.6 211.5h6.3l-2.3-2 1.8-5.4h3.6l.2-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M29.4 286.5l1.9 1.1 1 2.7 2.5 1.1 4.4 6.3 5.6 2.8 2.7 2.9.2 1.8 3.5 3.6 3.8 2.6.8 2.6 1.4-.1 3.1 1.3 1.6 1.6 1.6-.6 2.5 2.7 1.9.2 2.4 3.2h2.5l1.1 2.9 2.8-1.8v-8.7h.4l-.5-59.8-47.2-.1.2 27h1.5v2.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M29.4 286.5l1.9 1.1 1 2.7 2.5 1.1 4.4 6.3 5.6 2.8 2.7 2.9.2 1.8 3.5 3.6 3.8 2.6.8 2.6 1.4-.1 3.1 1.3 1.6 1.6 1.6-.6 2.5 2.7 1.9.2 2.4 3.2h2.5l1.1 2.9 2.8-1.8v-8.7h.4l-.5-59.8-47.2-.1.2 27h1.5v2.8z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M236.6 250.5h3.5l.4-22.7H218l-.3 22.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M236.6 250.5h3.5l.4-22.7H218l-.3 22.6z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M483.7 309.8l28.9-23.3-4.8-4.1-1.4-.1.2-1.8-2.1-1.9.2-1.1-1.6-1.2-1.5.8-2.8-1.2-16.5 2.6.2.8-4.1 1.2-.3 2.4 1.5.1.9 4.1 1.3.9.1 2.1-2.9 2.4v2l-.9 1.1.8 2.4-2 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2 2.6 1.8 3z"
}), React.createElement("path", {
  fill: "none",
  d: "M483.7 309.8l28.9-23.3-4.8-4.1-1.4-.1.2-1.8-2.1-1.9.2-1.1-1.6-1.2-1.5.8-2.8-1.2-16.5 2.6.2.8-4.1 1.2-.3 2.4 1.5.1.9 4.1 1.3.9.1 2.1-2.9 2.4v2l-.9 1.1.8 2.4-2 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2 2.6 1.8 3z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M481.7 205.1l15.6-.1v-21.7l-1.5.8-2.5-.5-4.5 1.3-3.6-.6-3.9 3-3.7.3-.9 1.9-3.6 2.1-.1 12.5h8.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M481.7 205.1l15.6-.1v-21.7l-1.5.8-2.5-.5-4.5 1.3-3.6-.6-3.9 3-3.7.3-.9 1.9-3.6 2.1-.1 12.5h8.6z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M376.5 228.5l5.3 14.4 7.2-4.3 7.3-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M376.5 228.5l5.3 14.4 7.2-4.3 7.3-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M177.4 159.8l1 22.9h22.7l-.5-22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M177.4 159.8l1 22.9h22.7l-.5-22.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M411.1 268.1l10.5-6.1 4.6 8 9.3-5.5-7.7-13.4-2 1.2-6.3-11.1-17.1 4.4.8 1-1.6 1.1 1 2.8-.9 1.4.3 2.1 2.7.5 1.9 1.9-2.6 2 3.5 2.2-1 1 2.3 1.5h2.2l-2 2.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M411.1 268.1l10.5-6.1 4.6 8 9.3-5.5-7.7-13.4-2 1.2-6.3-11.1-17.1 4.4.8 1-1.6 1.1 1 2.8-.9 1.4.3 2.1 2.7.5 1.9 1.9-2.6 2 3.5 2.2-1 1 2.3 1.5h2.2l-2 2.6z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M356.6 544.7l.7.6 2.7-.8v1.1l2.5 2.2 2.3.9 1.3 1.7 4.7 2.3 1.8.1.9-.9 2.5.1.4 1.6 1.7-1.3 2.9.6 4.5-.8v-17.8l-6.2-.7 2-8-1.2-.2v-8.1l-14.7-.1-11.6 25.7 1.1 1.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M356.6 544.7l.7.6 2.7-.8v1.1l2.5 2.2 2.3.9 1.3 1.7 4.7 2.3 1.8.1.9-.9 2.5.1.4 1.6 1.7-1.3 2.9.6 4.5-.8v-17.8l-6.2-.7 2-8-1.2-.2v-8.1l-14.7-.1-11.6 25.7 1.1 1.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M450.2 237.9l4.2 1.9.1 2 2.2.2 1.9 2.4 1.6-.6-.5 3 2.8.4-.6 2.9.5 1 1.7-.6.6 4.2 27.3-4.1-1.3-2.6-.8-.6.6-2.9-1.1-1.6 1.8-3.2-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M450.2 238l4.2 1.8.1 2 2.2.2 1.9 2.4 1.6-.6-.5 3 2.8.4-.6 2.9.5 1 1.7-.6.6 4.2 27.3-4.1-1.3-2.6-.8-.6.6-2.9-1.1-1.6 1.8-3.2-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M268.3 64.2h23.6V40.7l-23.6-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M268.3 64.2h23.6V40.7l-23.6-.1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M379.5 369.6l5.4-5.3-.8-1.3 4.5-3.1 1.3-2.2 2.3-1.8-20.3-16.8-5.5 16.1 11.7 9.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M379.5 369.6l5.4-5.3-.8-1.3 4.5-3.1 1.3-2.2 2.3-1.8-20.3-16.8-5.5 16.1 11.7 9.5z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M292.3 182.3l.1 22.8 22.7.2-.1-23.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M292.3 182.3l.1 22.8 22.7.2-.1-23.1z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M197.3 63.8V40.7h-38.5v23.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M197.3 63.8V40.7h-38.5v23.4z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M523.8 221.2v11.9l2.6 1.3 2.8.2 1-.7 2.8.7 2.3 1.6 2.4-.2 1.6 1.9 13.4-3.2v-15.6l-2.1.1-.5-2.5-1.8-.2-1.5 2.5-2-.5-.9-2.5-1.4.1-1 1.4-3.7 1.5h-5.5l-8.5-5.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M523.8 221.2v11.9l2.6 1.3 2.8.2 1-.7 2.8.7 2.3 1.6 2.4-.2 1.6 1.9 13.4-3.2v-15.6l-2.1.1-.5-2.5-1.8-.2-1.5 2.5-2-.5-.9-2.5-1.4.1-1 1.4-3.7 1.5h-5.5l-8.5-5.2z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M474.6 367.8l9.5 6.1 8.1 4.4 3.4-.3.7-.7 3 .3.4 2 1.6-.1 2.3 2.9 2.6-.6 4.6-5.4.7-3.3-4.9-3.8 1-3.4 2.5 5.3 3.7 2.4.6-1.3-1.2-.9 1.4-2.5.2-3-2.6-1.7-1.4-3.1.9-1.8-.9-1.8-1.4-.1-2.9-8.8-7.2 6.8-2.2-.1-1.6-2-2.7-.9-.6-1.2-2.2.7-1.1-2.1-2.2-1.3-1.8 1.7h-1.4l-2.1 1.8-7.3.9-5.4-4.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M474.6 367.8l9.5 6.1 8.1 4.4 3.4-.3.7-.7 3 .3.4 2 1.6-.1 2.3 2.9 2.6-.6 4.6-5.4.7-3.3-4.9-3.8 1-3.4 2.5 5.3 3.7 2.4.6-1.3-1.2-.9 1.4-2.5.2-3-2.6-1.7-1.4-3.1.9-1.8-.9-1.8-1.4-.1-2.9-8.8-7.2 6.8-2.2-.1-1.6-2-2.7-.9-.6-1.2-2.2.7-1.1-2.1-2.2-1.3-1.8 1.7h-1.4l-2.1 1.8-7.3.9-5.4-4.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M535.1 351.4l2 .8 4.6-1.1.7-2.5 1.9.1 1.1-1.1 4.1 1.4.9-2.2-1-1.9.9-.9-1-1.3 1.6-3.3-1.5-2.4.1-1.9 1.9-4.7h-20.7l.3 1.8-8.5.1 6 19.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M535.1 351.4l2 .8 4.6-1.1.7-2.5 1.9.1 1.1-1.1 4.1 1.4.9-2.2-1-1.9.9-.9-1-1.2 1.6-3.4-1.5-2.4.1-1.9 1.9-4.7h-20.7l.3 1.8-8.5.1 6 19.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M292 138.7l9.9 6.9 1.1-.4 3.2.7.9-.6 4.6 2.3.6-.9 1.9.4.7-1.1v-16.4l-1.9-1-2.7-.1-.9 2.2-4.1-.1-10-10.5-3.3.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M292 138.7l9.9 6.9 1.1-.4 3.2.7.9-.6 4.6 2.3.6-.9 1.9.4.7-1.1v-16.4l-1.9-1-2.7-.1-.9 2.2-4.1-.1-10-10.5-3.3.8z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M220.9 40.7h23.5V16.6h-23.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M220.9 40.7h23.5V16.6h-23.6z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M367.6 285l22.1-13.2-10.5-17.8-8.9 5.2 2.3 3.9-13.4 8.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M367.6 285l22.1-13.2-10.5-17.8-8.9 5.2 2.3 3.9-13.4 8.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M269.3 134h4.3l.1-23.1h-23.1l-.1 23.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M269.3 134h4.3l.1-23.1h-23.1l-.1 23.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M200.4 134l.2 25.8 22.9-.3-.1-25.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M200.4 134l.2 25.8 22.9-.3-.1-25.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M365.9 377.5l.5 1.7 1.9 1.1 1-.7 3 3.8 1.6-.3-.3 2.1.9 3.9 1.3-.7 10.7.1 9-13.7-2.9-.9-3-2.6-.5-1.9-1 .1-1.8-2.3-.2-2.2-1.2-.7-9.3 8.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M365.9 377.5l.5 1.7 1.9 1.1 1-.7 3 3.8 1.6-.3-.3 2.1.9 3.9 1.3-.7 10.7.1 9-13.7-2.9-.9-3-2.6-.5-1.9-1 .1-1.8-2.3-.2-2.2-1.2-.7-9.3 8.7z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M459.6 315.3l-.6 1.6.9 1.1-.7 3.1.6 2.6-1 3 1.2 1.6 1.8 6.4 1.7.6-2.9 2.4-.4 2.6 3.1 2.4-.4 3 12.7-1-1.2-19.6-1.4-11.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M459.6 315.3l-.6 1.6.9 1.1-.7 3.1.6 2.6-1 3 1.2 1.6 1.8 6.4 1.7.6-2.9 2.4-.4 2.6 3.1 2.4-.4 3 12.7-1-1.2-19.6-1.4-11.9z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M511.4 235.8h15.2l1.7.5.9-1.7-2.8-.2-2.6-1.3v-11.9l-2.5-.4-2.6 3.6-7.3 2.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M511.4 235.8h15.2l1.7.5.9-1.7-2.8-.2-2.6-1.3v-11.9l-2.5-.4-2.6 3.6-7.3 2.7z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M425.7 181.3l4.5.1.3.4 19.7.4.2-17.2-1.9-2.6-3.4.2-1.4-2.7-1.8.2-2.4-1.7 1.8-2.3-3.8-.9-.7 3.3-1 1-2.5.2-.4-1.6-2.3-.9-.8 1.4-1.4-1.1-.8-3.4-1.5-1.1-.4.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M425.7 181.3l4.5.1.3.4 19.7.4.2-17.2-1.9-2.6-3.4.2-1.4-2.7-1.8.2-2.4-1.7 1.8-2.3-3.8-.9-.7 3.3-1 1-2.5.2-.4-1.6-2.3-.9-.8 1.4-1.4-1.1-.8-3.4-1.5-1.1-.4.2z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M268.3 87.7V64.2h-23.9v23.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M268.3 87.7V64.2h-23.9v23.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M391.4 396.3l5 5.6 16.3-13.8 1.7-6.2-.1-3.7 3.2-3.1-8.2-7.1-12.2 7.7-1.6-.9-9.9 14.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M391.4 396.3l5 5.6 16.3-13.8 1.7-6.2-.1-3.7 3.2-3.1-8.2-7.1-12.2 7.7-1.6-.9-9.9 14.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M389.2 424l2 1.9 1.5 4.4 2.2 1 1.1-.4 2.8.7.2 3 2.6.8 2.1 1.8.7-.5 2.4 1.2 9.4-8.2-.9-2.9 1-8.2-1.2-2.8-2-1.7-2.7.9-2-2.4-3.4-1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M389.2 424l2 1.9 1.5 4.4 2.2 1 1.1-.4 2.8.7.2 3 2.6.8 2.1 1.8.7-.5 2.4 1.2 9.4-8.2-.9-2.9 1-8.2-1.2-2.8-2-1.7-2.7.9-2-2.4-3.4-1.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M214.2 250.5v22.4h22.3l.1-22.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M214.2 250.5v22.4h22.3l.1-22.4z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M322.5 342.6v7.7l31.2-.2-.1-18.3h-31.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M322.5 342.6v7.7l31.2-.2-.1-18.3h-31.2z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M240.6 205l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M240.6 205l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M535.3 379l-2.6 3 5.6-2.5v-2.1h-1.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M532.2 381.5l-7.6 3.3-4.1 3.7 2.2.3 3-3.4z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M521.6 390.7l-4.7 1.9-8.6 8.3 11-7.5z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M501.3 379.5l-.7 4.5 7.7 13.3 7.5-9.5-2.8-3.8 1.7-1.5-4.7-2.6-2.7.6-1.1 1.3-2.6.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M535.3 379l-2.6 3 5.6-2.5v-2.1h-1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M532.2 381.5l-7.6 3.3-4.1 3.7 2.2.3 3-3.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M521.6 390.7l-4.7 1.9-8.6 8.3 11-7.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M501.3 379.5l-.7 4.5 7.7 13.3 7.5-9.5-2.8-3.8 1.7-1.5-4.7-2.6-2.7.6-1.1 1.3-2.6.6z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M195.1 227.9h.4l-.2-22.7h-37.5v22.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M195.1 227.9h.4l-.2-22.7h-37.5v22.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M317.8 425.3l26.6-.3-.2-22.1-26.6-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M317.8 425.3l26.6-.3-.2-22.1-26.6-.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M445.3 265.5l11.4 19.6 19.6-10.5-.3-2.1-1.1-1.4-2.7-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M445.3 265.5l11.4 19.6 19.6-10.5-.3-2.1-1.1-1.4-2.7-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M497.3 205h5.9l.9-2.6 1.2-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M497.3 205h5.9l.9-2.6 1.2-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M463.1 377.2l1.3.7.8 2.4-.6 1.4 1.3.8-1.5 1.1 2.2 2.2.8-.2 2.2 4.1-.4.8 2.5 1.2.7 2.4 1.3.1 2.2-2.2 1.9-.9 4.3 1.7 2.8-1.8.8-2.9 1.1-.6-.1-2.1h3.8l1.7-7.1-8.1-4.4-9.5-6.1-6.3 3h-2.7l.8 2.2-2 .4 1.8.8-.3 2.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M463.1 377.2l1.3.7.8 2.4-.6 1.4 1.3.8-1.5 1.1 2.2 2.2.8-.2 2.2 4.1-.4.8 2.5 1.2.7 2.4 1.3.1 2.2-2.2 1.9-.9 4.3 1.7 2.8-1.8.8-2.9 1.1-.6-.1-2.1h3.8l1.7-7.1-8.1-4.4-9.5-6.1-6.3 3h-2.7l.8 2.2-2 .4 1.8.8-.3 2.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M289.8 159.2h9.3l.2 1 3.3-.3.4 1.1h2.1l.2-1.3 2.7.6 1.4 1.5 2-.6 2.7 1.6.8 1.8V146l-.7 1.1-1.9-.4-.6.9-4.6-2.3-.9.6-3.2-.7-1.1.4-9.9-6.9-.5-.9-1.6.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M289.8 159.2h9.3l.2 1 3.3-.3.4 1.1h2.1l.2-1.3 2.7.6 1.4 1.5 2-.6 2.7 1.6.8 1.8V146l-.7 1.1-1.9-.4-.6.9-4.6-2.3-.9.6-3.2-.7-1.1.4-9.9-6.9-.5-.9-1.6.6z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M223.5 159.5l22.9-.2-.1-25.3h-22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M223.5 159.5l22.9-.2-.1-25.3h-22.9z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M263 227.8l22.5.1.1-22.8-22.4-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M263 227.8l22.5.1.1-22.8-22.4-.1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M417 375.9l11.7-.3 6.9-8 6.5-8.6-2.3-4.1-1.1-5.1-5.3.3-1.2-1.1-2.2 2.2-7.6 4.3-.2-1-12.9 13.5 8.2 7.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M417 375.9l11.7-.3 6.9-8 6.5-8.6-2.3-4.1-1.1-5.1-5.3.3-1.2-1.1-2.2 2.2-7.6 4.3-.2-1-12.9 13.5 8.2 7.1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M454.1 184.7l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.3 4-2.3.6-2-1.1-1.2 1-.6 2.8-1.9.3-.8-1.8-.2 20.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M454.1 184.7l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.3 4-2.3.6-2-1.1-1.2 1-.6 2.8-1.9.3-.8-1.8-.2 20.2z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M420.2 307l20.7-12-9-15.5-20.8 12.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M420.2 307l20.7-12-9-15.5-20.8 12.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M370.3 259.2l15.1-8.8-3.6-7.5-5.3-14.4-17.8-.1v11.1l-3.4 1.9 9.8 16.6 3.4-2z"
}), React.createElement("path", {
  fill: "none",
  d: "M370.3 259.2l15.1-8.8-3.6-7.5-5.3-14.4-17.8-.1v11.1l-3.4 1.9 9.8 16.6 3.4-2z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M419.5 241.2l6.3 11.1 24.4-14.4-3-1.5.8-2.7-1.9-1.2-1.4-2.5.3-2.3-1.2-1-24.4-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M419.5 241.2l6.3 11.1 24.4-14.3-3-1.6.8-2.7-1.9-1.2-1.4-2.5.3-2.3-1.2-1-24.4-.2z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M20.9 282.8l5.1 3.1 3.4.6 1.7-1.9v-2.8h-1.5l-.2-27-27.2.1.3 4.2-1.5 1.1 1.8 3.6 2.6 1.1 2.4 3 1.7-.8 3.1 1.7 3.2 5.2 1.2 3.5 1.6 1.2 1.1 2.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M20.9 282.8l5.1 3.1 3.4.6 1.7-1.9v-2.8h-1.5l-.2-27-27.2.1.3 4.2-1.5 1.1 1.8 3.6 2.6 1.1 2.4 3 1.7-.8 3.1 1.7 3.2 5.2 1.2 3.5 1.6 1.2 1.1 2.9z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M261.3 376.1h30l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1.1-1-1-2.4 1.4-2.7.6-6.5.7.1.2-3 2.2.5 7-.1.2-10.9-41.4.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M261.3 376.1h30l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1.1-1-1-2.4 1.4-2.7.6-6.5.7.1.2-3 2.2.5 7-.1.2-10.9-41.4.1z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M169.4 272.9h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M169.4 272.9h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M339 250.9l19.7-11.4v-11.1l-28-.1-.2 22.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M339 250.9l19.7-11.4v-11.1l-28-.1-.2 22.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M344.3 454.3l.2 34.8 7.6-.2 4.5.8-.1 3.8 12.8.1-.1-39.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M344.3 454.3l.2 34.8 7.6-.2 4.5.8-.1 3.8 12.8.1-.1-39.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M250.6 110.9h17.7V87.7h-23.9l-.2 23.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M250.6 110.9h17.7V87.7h-23.9l-.2 23.2z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M286.9 425l.1 22.4 31.4-.4v-21.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M286.9 425l.1 22.4 31.4-.4v-21.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M246.4 159.3l.1 23 22.8-.1-.1-23z"
}), React.createElement("path", {
  fill: "none",
  d: "M246.4 159.3l.1 23 22.8-.1-.1-23z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M398.1 416.7l6.9-5.6 3.4 1.5 1.4 1.6 14.5-12-11.6-14.1-22.5 18.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M398.1 416.7l6.9-5.6 3.4 1.5 1.4 1.6 14.5-12-11.6-14.1-22.5 18.9z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M421.8 203.9l8.3-.2.4-21.9-.3-.4-23.7-.9-.7 23.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M421.8 203.9l8.3-.2.4-21.9-.3-.4-23.7-.9-.7 23.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M497.3 183.3l-2.8-.7-5.3-3.4-1.5.5-1.5-1.5-3.6-.6-1.6.8-3.4-1.3-3 1.9-1.4-.1-.1 12.7 3.6-2.1.9-1.9 3.7-.3 3.9-3 3.6.6 4.5-1.3 2.5.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M497.3 183.3l-2.8-.7-5.3-3.4-1.5.5-1.5-1.5-3.6-.6-1.6.8-3.4-1.3-3 1.9-1.4-.1-.1 12.7 3.6-2.1.9-1.9 3.7-.3 3.9-3 3.6.6 4.5-1.3 2.5.5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M181.4 111H197l.1-23.3h-38.3l-.1 23.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M181.4 111H197l.1-23.3h-38.3l-.1 23.2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M195.5 227.9l22.5-.1-.1-22.8-22.6.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M195.5 227.9l22.5-.1-.1-22.7-22.6.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M443.8 226.7l.6-22.7-22.6-.4-.2 23z"
}), React.createElement("path", {
  fill: "none",
  d: "M443.8 226.7l.6-22.7-22.6-.4-.2 23z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M197.3 40.7V16.5h-38.5v24.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M197.3 40.7V16.5h-38.5v24.2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M76.7 323.4l35.7-22.5 3.4-45.9-39.2-.1.5 59.8h-.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M76.7 323.4l35.7-22.5 3.4-45.9-39.2-.1.5 59.8h-.4z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M223.5 159.5l.3 22.9 22.7-.1-.1-23z"
}), React.createElement("path", {
  fill: "none",
  d: "M223.5 159.5l.3 22.9 22.7-.1-.1-23z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M214.5 324h2.6l2.5 1.6-.5 1.7.7 1.9-1.4 1.5-.9 3.2-1.1-.7-.7 2.5 3.6 3.4-3.6 1.7-.7 1.7h34.9l-.1-40.4-62.4-.3 2.6 1 2.2 1.8 3.3.1 2.8 1.9 2.6.4 2.1-.6 1.7.4 5.2 4-.7 1.1 1.3.8 1.9 6.3.3 2.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M214.5 324h2.6l2.5 1.6-.5 1.7.7 1.9-1.4 1.5-.9 3.2-1.1-.7-.7 2.5 3.6 3.4-3.6 1.7-.7 1.7h34.9l-.1-40.4-62.4-.3 2.6 1 2.2 1.8 3.3.1 2.8 1.9 2.6.4 2.1-.6 1.7.4 5.2 4-.7 1.1 1.3.8 1.9 6.3.3 2.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M187.4 301.8l3.8.1-.7-29h-19.7v18.4l4-1.7 4.3 2.8 2.5.4 2.8 2.1 1.2 1.7v3.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M187.4 301.8l3.8.1-.7-29h-19.7v18.4l4-1.7 4.3 2.8 2.5.4 2.8 2.1 1.2 1.7v3.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M269.2 159.2h20.6l.1-20.8 1.6-.6.5.9v-4.6l-22.7-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M269.2 159.2h20.6l.1-20.8 1.6-.6.5.9v-4.6l-22.7-.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M371.6 282.6l11.9 20.1 21.4-12.8-11.9-20.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M371.6 282.6l11.9 20.1 21.4-12.8-11.9-20.1z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M406.5 180.5l19.2.8v-28.1l-2.3.4.5 3-1.7 2.2-1.5-.7-1.3.9 1.7 1.2-1.7.5v3.6l-1 1.1-1.8-.2-1.8-2-.2-3.7 1.3-.5-.8-3.2-1.1-.8-1.5.8-.4 2-3.4-1.1-1.8 3.4-3.1-.2-.8-1 .5-2.6-1.5-1.3-.1 25.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M406.5 180.5l19.2.8v-28.1l-2.3.4.5 3-1.7 2.2-1.5-.7-1.3.9 1.7 1.2-1.7.5v3.6l-1 1.1-1.8-.2-1.8-2-.2-3.7 1.3-.5-.8-3.2-1.1-.8-1.5.8-.4 2-3.4-1.1-1.8 3.4-3.1-.2-.8-1 .5-2.6-1.5-1.3-.1 25.4z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M286.9 301.8h22.4l.1-20.7-1.1 1.2-2.2-1.5 1-1.5-1.7-.6.8-.8-2.1-1.2-17-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M286.9 301.8h22.4l.1-20.7-1.1 1.2-2.2-1.5 1-1.5-1.7-.6.8-.8-2.1-1.2-17-.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M339 250.9l11.2 19.5 7.7-1.2 1.3 2 13.4-8.1-4.1-7.1-3.4 2-9.8-16.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M339 250.9l11.2 19.5 7.7-1.2 1.3 2 13.4-8.1-4.1-7.1-3.4 2-9.8-16.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M351.2 370l1.9.2 2.2-1 1.1 1 4.6-.1 3.6 1-1.8 1 .1 2 1.6.5-.2 1.7 1.6 1.2 9.7-4.5 3.9-3.4-1.4-4.9-11.7-9.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M351.2 370l1.9.2 2.2-1 1.1 1 4.6-.1 3.6 1-1.8 1 .1 2 1.6.5-.2 1.7 1.6 1.2 9.7-4.5 3.9-3.4-1.4-4.9-11.7-9.5z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M428.7 375.6l1.4.9.5 1.9h1.7l10.2 12.2-4.3 3.6.8.8 12.8-8.1 1.7-5.3 5.8-6-1.1-1.2-2.4-.4-.6-2.6-1.8-2-.9-3-3.6-.5-5.3-4.1-1.5-2.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M428.7 375.6l1.4.9.5 1.9h1.7l10.2 12.2-4.3 3.6.8.8 12.8-8.1 1.7-5.3 5.8-6-1.1-1.2-2.4-.4-.6-2.6-1.8-2-.9-3-3.6-.5-5.3-4.1-1.5-2.8z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M268.3 110.9l23.6.1V87.7h-23.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M268.3 110.9l23.6.1V87.7h-23.6z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M430.1 203.7l23.9.3.1-19.3-3.9.5v-3l-19.7-.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M430.1 203.7l23.9.3.1-19.3-3.9.5v-3l-19.7-.4z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M304.1 276.7l2.1 1.2-.8.8 1.7.6-1 1.5 2.2 1.5 1.1-1.2 2.8.4 1 3.1 3.3-1.1-.5-1.3 5.9 3.1 3.3-3.7 1.6.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M304.1 276.7l2.1 1.2-.8.8 1.7.6-1 1.5 2.2 1.5 1.1-1.2 2.8.4 1 3.1 3.3-1.1-.5-1.3 5.9 3.1 3.3-3.7 1.6.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M255.8 270.6l25.8.2v-20.1l-25.6-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M255.8 270.6l25.8.2v-20.1l-25.6-.2z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M178.4 182.7l-1-22.9h-18.9l-.4 22.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M178.4 182.7l-1-22.9h-18.9l-.4 22.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M361 178.6h19.4v-22.2l.9-1.3-.6-1.2 1.1-2.9-1.2-.8-1.8.7-3-.5v-2l-1.6-1.6 1.3-2.7-.5-1.3-1.6.3-1.3 1.4-2.8-1h-3l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M361 178.6h19.4v-22.2l.9-1.3-.6-1.2 1.1-2.9-1.2-.8-1.8.7-3-.5v-2l-1.6-1.6 1.3-2.7-.5-1.3-1.6.3-1.3 1.4-2.8-1h-3l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M292 134.1l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M292 134.1l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M492 250.6l.2 3.4-1.3 3 1.5 1.8-.8 1.2-.1 3.1 1.2.4.6 3.5 2.7 1.6 2.1 2.6.7 4.7 2.8 1.2 1.5-.8 1.6 1.2-.2 1.1 2.1 1.9-.2 1.8 1.4.1 2.8 2.1 6.1-5.2-2.6-2.7-1.8-5.9v-3l1.7-.5-2.1-1 1.6-3.3h-2.1v-15.1l-20.7.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M492 250.6l.2 3.4-1.3 3 1.5 1.8-.8 1.2-.1 3.1 1.2.4.6 3.5 2.7 1.6 2.1 2.6.7 4.7 2.8 1.2 1.5-.8 1.6 1.2-.2 1.1 2.1 1.9-.2 1.8 1.4.1 2.8 2.1 6.1-5.2-2.6-2.7-1.8-5.9v-3l1.7-.5-2.1-1 1.6-3.3h-2.1v-15.1l-20.7.2z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M511.7 362.9l.5 1.3 2.6 1.7-.2 3-1.4 2.5 1.2.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.2-2.5 5.5 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5v2.1l.7-.3-.1-16.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M511.7 362.9l.5 1.3 2.6 1.7-.2 3-1.4 2.5 1.2.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.2-2.5 5.5 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5v2.1l.7-.3-.1-16.4z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M200.4 134h4.1v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  fill: "none",
  d: "M200.4 134h4.1v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M552.7 209.3v-20.4l-.6-1.4-3.7.2-1.1-.9-2.3.8-.5 2.5-6.6-.4-1.5-1.5-4.5.1-.5.8-3.9 1.1-1.5-1.2-.1 20.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M552.7 209.3v-20.4l-.6-1.4-3.7.2-1.1-.9-2.3.8-.5 2.5-6.6-.4-1.5-1.5-4.5.1-.5.8-3.9 1.1-1.5-1.2-.1 20.3z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M244.4 87.7V63.9l-23.5.1v23.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M244.4 87.7V63.9l-23.5.1v23.7z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M504.1 208.1l18.9-.1-2.2-1.2-2.1-2.9-1.9-1.2-3.6-3.6-4.3.3-2.6 1.9h-1l-1.2 1.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M504.1 208.1l18.9-.1-2.2-1.2-2.1-2.9-1.9-1.2-3.6-3.6-4.3.3-2.6 1.9h-1l-1.2 1.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M385.5 552.1l1.2 1.1 1.5-.7 1.6 1.6 2.5-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.9.1.1 1.4 3.5.7.7-2.2-.7-1 1.1-1.2 3.1-.2 3-1.4 2.7.4-.2-3.5-4.4 3.1.7-4.9-3.3-2.8.7-3.3-2-6.9-3.3-1.9-1.3 2.2-2.7-.4-.9 1.7-14.6-2.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M385.5 552.1l1.2 1.1 1.5-.7 1.6 1.6 2.5-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.9.1.1 1.4 3.5.7.7-2.2-.7-1 1.1-1.2 3.1-.2 3-1.4 2.7.4-.2-3.5-4.4 3.1.7-4.9-3.3-2.8.7-3.3-2-6.9-3.3-1.9-1.3 2.2-2.7-.4-.9 1.7-14.6-2.4z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M308.1 250.8h22.4l.2-22.5h-22.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M308.1 250.8h22.4l.2-22.5h-22.6z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M450.1 423.6l2.8 1.7v-1.7z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M431.1 449l-1.2 5 7-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M428 432l3.7 3.7.9-.7 3.4 2 2.5 3.7 9.6-5 .7-1.5-6.6-6-3.1.6 1.1-3.4-2.1-3.2-2.7 1.7-5.8 1.7-3.3 2.4 1.2 1z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M441.9 422.1l.5 3 5.6 2.1.3-5.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M450.1 423.6l2.8 1.7v-1.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M431.1 449l-1.2 5 7-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M428 432l3.7 3.7.9-.7 3.4 2 2.5 3.7 9.6-5 .7-1.5-6.6-6-3.1.6 1.1-3.4-2.1-3.2-2.7 1.7-5.8 1.7-3.3 2.4 1.2 1z"
}), React.createElement("path", {
  fill: "none",
  d: "M441.9 422.1l.5 3 5.6 2.1.3-5.2z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M384.9 364.3l1.2.7.2 2.2 1.8 2.3 1-.1.5 1.9 3 2.6 4.5 1.8 12.3-7.8-14.6-14.2-4.9 4-1.3 2.2-4.5 3.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M384.9 364.3l1.2.7.2 2.2 1.8 2.3 1-.1.5 1.9 3 2.6 4.5 1.8 12.3-7.8-14.6-14.2-4.9 4-1.3 2.2-4.5 3.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M360 310.3l-.6 2.2 1.4.6.2 1.6h1.9l-2.3 2.6.1 1.6 2.4.3-1.8 2.3.5 1.3-1.5.1 1.7 3.9v1.7l2.2.3v3.7l9.8 3 1.2-2.1-.8-1.7 6.7-14.5 5.9-6.1-3.7-6.6-23.1.3-.8 1.1.5 2.9 1.4.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M360 310.3l-.6 2.2 1.4.6.2 1.6h1.9l-2.3 2.6.1 1.6 2.4.3-1.8 2.3.5 1.3-1.5.1 1.7 3.9v1.7l2.2.3v3.7l9.8 3 1.2-2.1-.8-1.7 6.7-14.5 5.9-6.1-3.7-6.6-23.1.3-.8 1.1.5 2.9 1.4.4z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M439 342.1l14.9-4.3.3-3.2-2.1-1.5-.8-3.5-2.6-.1-.1-2-4.2-2.2-3.7-.8 1.5-2.7-2.4-1.8-15 8.9 2 .9 2.1 5.2 2 1 2.4 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M439 342.1l14.9-4.3.3-3.2-2.1-1.5-.8-3.5-2.6-.1-.1-2-4.2-2.2-3.7-.8 1.5-2.7-2.4-1.8-15 8.9 2 .9 2.1 5.2 2 1 2.4 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M326.8 282.4l4.9.3 2.2-1.5 1 1.1 10.4-7.3.9-4 4-.6-11.2-19.5h-11.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M326.8 282.4l4.9.3 2.2-1.5 1 1.1 10.4-7.3.9-4 4-.6-11.2-19.5h-11.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M356.5 493.5l1.4 1.5v4.6h1.1v4.3l2.2-.1-.2 13.4 19.1.1v-23.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M356.5 493.5l1.4 1.5v4.6h1.1v4.3l2.2-.1-.2 13.4 19.1.1v-23.6z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M246.3 134h4.2l.1-23.1h-23.1V134z"
}), React.createElement("path", {
  fill: "none",
  d: "M246.3 134h4.2l.1-23.1h-23.1V134z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M125.9 394.2l3.2 4.1 7.2 1.1 4.6 4.3.7 1.4 5.9 1.9.9 1.5 2.3-.7 3.2 1 1.7-.7.6-3.7 1.1-1.6 1.9-.7 2.6-4 1 .6 2.6-1.8.9-1.4-1.4-.8 1-5.1 1.7-.3.7-1.8-.3-2.4 1-3.9 1.6-1.4.2-2.3 1 .1.1-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-48.9-39.9-15.8 12.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M125.9 394.2l3.2 4.1 7.2 1.1 4.6 4.3.7 1.4 5.9 1.9.9 1.5 2.3-.7 3.2 1 1.7-.7.6-3.7 1.1-1.6 1.9-.7 2.6-4 1 .6 2.6-1.8.9-1.4-1.4-.8 1-5.1 1.7-.3.7-1.8-.3-2.4 1-3.9 1.6-1.4.2-2.3 1 .1.1-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-48.9-39.9-15.8 12.9z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M453.9 337.8l1.2 1.1 3.2-1.2 2.1.6-.2 2 .4-2.6 2.9-2.4-1.7-.6-1.8-6.4-1.2-1.6 1-3-.6-2.6.7-3.1-.9-1.1.6-1.6-1.9-4.5.2-1.8-1.4-1.4-4.2 2.7-2.2 2.9-3.1 6.1-4.8 2.5-1.5 2.7 3.7.8 4.2 2.2.1 2 2.6.1.8 3.5 2.1 1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M453.9 337.8l1.2 1.1 3.2-1.2 2.1.6-.2 2 .4-2.6 2.9-2.4-1.7-.6-1.8-6.4-1.2-1.6 1-3-.6-2.6.7-3.1-.9-1.1.6-1.6-1.9-4.5.2-1.8-1.4-1.4-4.2 2.7-2.2 2.9-3.1 6.1-4.8 2.5-1.5 2.7 3.7.8 4.2 2.2.1 2 2.6.1.8 3.5 2.1 1.5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M488.6 416.1l5.3-1.9 6.6-6.4 3.7-9.5 4.1-1-7.7-13.3.7-4.5-1.6.1-.4-2-3-.3-.7.7-3.4.3-1.7 7.1h-3.8l.1 2.1-1.1.6-.8 2.9-2.8 1.8-4.3-1.7-1.9.9-3.4 3.9 1.3 1.2-.1 4.9 3.5 2.7-.8.7.9 3.6 3.9.2 1.3 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  fill: "none",
  d: "M488.6 416.1l5.3-1.9 6.6-6.4 3.7-9.5 4.1-1-7.7-13.3.7-4.5-1.6.1-.4-2-3-.3-.7.7-3.4.3-1.7 7.1h-3.8l.1 2.1-1.1.6-.8 2.9-2.8 1.8-4.3-1.7-1.9.9-3.4 3.9 1.3 1.2-.1 4.9 3.5 2.7-.8.7.9 3.6 3.9.2 1.3 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M526 189l1.5 1.2 3.9-1.1.5-.8 4.5-.1 1.5 1.5 6.6.4.5-2.5 2.3-.8 1.1.9 3.7-.2.6 1.4v-14.8l-1.8-1.2-2.8.6-1.6-1.6-1.5 2-2.5-.1-.4-1.2-1.1 1.6-1.6-.8-.3 1.2-1.6-.2-4.2-4.8-1.5 1.1-.4-1.2-1.5.8.7-1.8-1.9.7-1.3-1.9-.8 1-1.3-1.6-.7.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M526 189l1.5 1.2 3.9-1.1.5-.8 4.5-.1 1.5 1.5 6.6.4.5-2.5 2.3-.8 1.1.9 3.7-.2.6 1.4v-14.8l-1.8-1.2-2.8.6-1.6-1.6-1.5 2-2.5-.1-.4-1.2-1.1 1.6-1.6-.8-.3 1.2-1.6-.2-4.2-4.8-1.5 1.1-.4-1.2-1.5.8.7-1.8-1.9.7-1.3-1.9-.8 1-1.3-1.6-.7.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M379.2 254l10.5 17.8 3.3-2 3.7 6.4 14.4-8.1-2.1-2.4 2-2.6h-2.2l-2.3-1.5 1-1-3.5-2.2 2.6-2-1.9-1.9-2.7-.5-.3-2.1.9-1.4-1-2.8 1.6-1.1-.8-.6-1.6.6-.2 1.5-2.3-.9.1-1.4-2.8-1.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M379.2 254l10.5 17.8 3.3-2 3.7 6.4 14.4-8.1-2.1-2.4 2-2.6h-2.2l-2.3-1.5 1-1-3.5-2.2 2.6-2-1.9-1.9-2.7-.5-.3-2.1.9-1.4-1-2.8 1.6-1.1-.8-.6-1.6.6-.2 1.5-2.3-.9.1-1.4-2.8-1.6z"
}), React.createElement("path", {
  fill: "#8e98c8",
  d: "M217.9 205l.1 22.8h22.5l.1-22.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M217.9 205.1l.1 22.7h22.5l.1-22.8z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M353.6 331.8l.1 18.3 7.6 10.1 5.1-5 5.5-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M353.6 331.8l.1 18.3 7.6 10.1 5.1-5 5.5-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M344.2 394.8l17.4 6.9 12-16.5.3-2.1-1.6.3-3-3.8-1 .7-1.9-1.1-.5-1.7-1.6-1.2.2-1.7-1.6-.5-.1-2 1.8-1-3.6-1-4.6.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M344.2 394.8l17.4 6.9 12-16.5.3-2.1-1.6.3-3-3.8-1 .7-1.9-1.1-.5-1.7-1.6-1.2.2-1.7-1.6-.5-.1-2 1.8-1-3.6-1-4.6.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M383.3 304.5l3.7 6.6 8.9 1.8 13.5 6 2.5-7 8.3-4.9-9.1-15-2.9 1.8-3.3-3.9-21.4 12.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M383.3 304.5l3.7 6.6 8.9 1.8 13.5 6 2.5-7 8.3-4.9-9.1-15-2.9 1.8-3.3-3.9-21.4 12.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M387.4 448.4l11 2.4 8.4-12.9-2.4-1.2-.7.5-2.1-1.8-2.6-.8-.2-3-2.8-.7-1.1.4-2.2-1-1.5-4.4-2-1.9-2.1-.1-4.1-2.5-7.5 2.8 12.3 23.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M387.4 448.4l11 2.4 8.4-12.9-2.4-1.2-.7.5-2.1-1.8-2.6-.8-.2-3-2.8-.7-1.1.4-2.2-1-1.5-4.4-2-1.9-2.1-.1-4.1-2.5-7.5 2.8 12.3 23.9z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M314.9 159.3l.1 22.9 22.7.1.1-23z"
}), React.createElement("path", {
  fill: "none",
  d: "M314.9 159.3l.1 22.9 22.7.1.1-23z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M394.8 353.7l14.6 14.2 12.8-13.4-2.5-10.5-5.2-4-7.4-4.2-5.4 10.7z"
}), React.createElement("path", {
  fill: "none",
  d: "M394.8 353.7l14.6 14.2 12.8-13.4-2.5-10.5-5.2-4-7.4-4.2-5.4 10.7z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M309.3 375.9l27.1.2-.1 3 2.6.1 6.5-8-17.4-8.8-18.6-.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M309.3 375.9l27.1.2-.1 3 2.6.1 6.5-8-17.4-8.8-18.6-.6z"
}), React.createElement("path", {
  fill: "#e3e5f1",
  d: "M158.5 159.8h18.9l.1-25.8h-18.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M158.5 159.8h18.9l.1-25.8h-18.8z"
}), React.createElement("path", {
  fill: "#5664ad",
  d: "M442.1 359l1.5 2.8 5.3 4.1 3.6.5.9 3 1.8 2 .6 2.6 2.4.4 1.1 1.2 2.7.5 1.1 1.1 2.8-.1.3-2.9-1.8-.8 2-.4-1.6-6-2.3-.3-.8-1.5 1.2-2-1.4-1-.2-1.8 1.6-1.3-1.1-4.6-1.2-1-.7.9-5.6-2.2-10 1.6h-2.9l-1.6 1.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M442.1 359l1.5 2.8 5.3 4.1 3.6.5.9 3 1.8 2 .6 2.6 2.4.4 1.1 1.2 2.7.5 1.1 1.1 2.8-.1.3-2.9-1.8-.8 2-.4-1.6-6-2.3-.3-.8-1.5 1.2-2-1.4-1-.2-1.8 1.6-1.3-1.1-4.6-1.2-1-.7.9-5.6-2.2-10 1.6h-2.9l-1.6 1.1z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M344.2 402.9l.2 22.1h20.4v1.7l10.4-8.7-13.6-16.3-17.4-6.9z"
}), React.createElement("path", {
  fill: "none",
  d: "M344.2 402.9l.2 22.1h20.4v1.7l10.4-8.7-13.6-16.3-17.4-6.9z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M220.6 110.9h23.6l.2-23.2h-23.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M220.6 110.9h23.6l.2-23.2h-23.5z"
}), React.createElement("path", {
  fill: "#727eba",
  d: "M337.7 182.3h23.4l-.2-23.1-23.1.1z"
}), React.createElement("path", {
  fill: "none",
  d: "M337.7 182.3h23.4l-.2-23.1-23.1.1z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M421.6 447.2l2.2 3.6 3.3-.3 4.5-4.2.8-5-14.6 2.4 1 2.2z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M428.8 450.7l-3.9 5.4-4.1 8.7 9-10.8z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M415.2 458.6l2.2 3.5 4.5-7.3.3-3.2-4.9 3.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M420.7 463.9v-.3z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M419.8 461.3l.2.5-.2-.5z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M420 461.8l.2.6-.1-.2z"
}), React.createElement("path", {
  fill: "#3a4a9f",
  d: "M411.8 453.4l3.2 5.1 1.7-3z"
}), React.createElement("path", {
  fill: "none",
  d: "M421.6 447.2l2.2 3.6 3.3-.3 4.5-4.2.8-5-14.6 2.4 1 2.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M428.8 450.7l-3.9 5.4-4.1 8.7 9-10.8z"
}), React.createElement("path", {
  fill: "none",
  d: "M415.2 458.6l2.2 3.5 4.5-7.3.3-3.2-4.9 3.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M420.7 463.9v-.3z"
}), React.createElement("path", {
  fill: "none",
  d: "M419.8 461.3l.2.5-.2-.5z"
}), React.createElement("path", {
  fill: "none",
  d: "M420 461.8l.2.6-.1-.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M411.8 453.4l3.2 5.1 1.7-3z"
}), React.createElement("path", {
  fill: "#abb1d6",
  d: "M510.6 284.5l2 2-.1 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.5 2.2 5.5.9 2.3 1.4 4.5 1.3 14.4-3.4-2.8-1.9-1.4-2-1.6-.2-2.8-2.3-2.5-2.5-.6-1.5-2.3-.9-2.3-4.6-1.6.6-.7-1.9-5.8-.8-5.3-2-.7.3-1.8-2.2z"
}), React.createElement("path", {
  fill: "none",
  d: "M510.6 284.5l2 2-.1 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.5 2.2 5.5.9 2.3 1.4 4.5 1.3 14.4-3.4-2.8-1.9-1.4-2-1.6-.2-2.8-2.3-2.5-2.5-.6-1.5-2.3-.9-2.3-4.6-1.6.6-.7-1.9-5.8-.8-5.3-2-.7.3-1.8-2.2z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M157.8 227.9v22.6h37.3v-22.6z"
}), React.createElement("path", {
  fill: "none",
  d: "M157.8 227.9v22.6h37.3v-22.6z"
}), React.createElement("path", {
  fill: "#c7cbe4",
  d: "M464.7 254.7l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.7.7 1.1 1.4.3 2.1.9 1.1 1.4-2.9 1.1 1.9-.8 1.7.5 1.5-1.6.1.6 2.5 4.1-1.2-.2-.8 16.5-2.6-.7-4.7-2.1-2.6-2.7-1.6-.6-3.5-1.2-.4.1-3.1.8-1.2-1.5-1.8 1.3-3-.2-3.4z"
}), React.createElement("path", {
  fill: "none",
  d: "M464.7 254.7l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.7.7 1.1 1.4.3 2.1.9 1.1 1.4-2.9 1.1 1.9-.8 1.7.5 1.5-1.6.1.6 2.5 4.1-1.2-.2-.8 16.5-2.6-.7-4.7-2.1-2.6-2.7-1.6-.6-3.5-1.2-.4.1-3.1.8-1.2-1.5-1.8 1.3-3-.2-3.4z"
}), React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "M450.4 165l-1.9-2.6-3.4.2-1.4-2.7-1.8.2-2.4-1.7 1.8-2.2h0l-3.7-.9-.6 2.7-.1.6-1 1-2.4.2-.4-1.5v-.1l-1-.4-1.3-.5-.8 1.5-1.4-1.1-.7-3.5-1.5-1.1-.4.3-2.3.3h0l.5 3-1.7 2.2-.4-.2-1.1-.5-1.3.9h0l1.7 1.2-1.8.5v3.7l-.3.3-.7.8-1.8-.2-1.8-2-.2-3.6 1.3-.6-.8-3.2-.6-.5-.7-.5-1.6.8-.4 1.9-2.1-.7-1.3-.4-1.3 2.4-.5 1-1.7-.1-1.4-.1-.6-.7-.3-.3.5-2.6-.7-.6-.6-.6-1.4.4-1.9.5-1.2-.2v-2.5l-1.8-1.2-1.4-.9-.4.1-.8.1-1.8 2.4-.2.2-1.1.1h-.2l-.6.8-2.5 3.2-1.6.5-4.7-2.2.5-.7.4-.6-.6-1.2 1.1-2.8h0l-1.2-.8h0l-.4.1-1.5.5-3-.5h0v-2l-1.6-1.6.9-1.9.4-.7h0l-.5-1.3-1.6.3-1.3 1.5-2.8-1.1h-3l-2.8-1.2-1.5 1.5-.4.8-.7 1.6h0v.1m92.1 278.3v.6h0l5-2.8-.8 1.8-.4.9 3.6 1.5 5-2 2.1 2.6-6.8 2.9-8.3 5.2h0l16.4-8.8 1.1-2.9.5-1.4 1.1-.4 4.9-1.8 4.7-.1-10.4 5.5h0l5.7-2 2.1-1.5 2.8-2h.8l4-2.4 2.4-1.4 2.2-.8 3.1-1.1 5.1-4.9 1.5-1.5 1-2.6 2.7-6.8 3.6-.9.4-.1 1.6-2 5.9-7.5h0L513 384l.5-.4 1.3-1.1h0l-4.7-2.6-2.7.6h0l-.1.2-.9 1.1 3.4-4 1.2-1.3.1-.7.5-2.7h0l-4.9-3.8 1-3.5 2.5 5.3 3.8 2.4 2.5.1h0l2-3.5.5-.9 3.3-1.6 1.9 1.7-.4 6.2-1.2 2.6-1.3 2.9h0l7-1.8 2.5-.6 3.3.8.8-.3.5-.2-2.6 2.9h0l5.6-2.4.7-.3h.1l.2-.1 14.6-5.9h7.7l-4.8-5.1-.2-3.5 3.6-4.5h0l-.1-2.2 5.1-1.7 1.4-1.8 1-.5h0l-1.1-.9-.4-.3 1.8-2.6-1.2-3.8.6-1.7v-.1l.1-2.3h0l-1.6-.6-.9-2.7.9-2.5.4-.4 1.6-1.7-1.6-4.5.3-2.2 2.1-1.2h0l-.2-2.1 1.7-1.5.5-.4 1-1.9-.3-2.1.1-.2 2.5-3.8h0l-.2-4 1.4-.8h0l-.3-1.4-1.6-.6.5-1.8 2.1-1.3h0l-.8-2.3-1.6-1.1.6-.6.4-.4h0l-.6-3.6-2.1.2V294h0l-3.9-4.1.4-1.3.4-1.5h0l-.2-1.7-1.3-.7.3-.7.2-.6-2.5-1.6 1.6-2.3h0l-3.2-.6-2.2-3.1.7-1.5h0l-.1-3.1 1.2-1.4h0l-1.9-2.5.6-1.2h0l-2.3-2.5-1-3.2-1.5-1.4-1.8-.4-2-3.1h0l-.8-.7-.4-.3v-45.7h0v-35.1l-1.7-1.2h0l-.4.1-2.4.5-1.6-1.5-1.5 2-1.5-.1h-1l-.3-1.3-1.1 1.6-1.6-.8h0l-.4 1.2-1.1-.1h-.5l-4.2-4.8h0l-1.5 1.1-.3-1.3-1.4.7-.1.1.4-.9.4-.9h0l-1.9.8-1.3-1.9h0l-.2.2-.6.8-1.3-1.6-.7.5-2.7-1-1.1-3-.5.5-.9 1-.9-1.9-1.1 1.6-2.7-2-.5-1.6-1.3-.4-.1-.3-.6-2.1-2.4-.1-1.1-.1-.5-2-1 1.2-1.5-1.3-.5-1.7h-1.2l-2.8-1.3-2.3 2.6-.5 1.9-1.2-.1-5.6.5-.9-1.1-3.7.4-.6-2.6-1.7-.6-1.3 1.8h0-1.8 0l-1.2 1.1-2.3-.2h-.4 0l-.5 2.4-1.6-.8-1.7 1.3-3.9-2.5h0l-.4 1.3-3.3.9-1.3.4-2.3-.5-2.1.5-1.3 4-2.3.6-2.1-1.1-1.1 1-.7 2.8-1.9.3-.8-1.8m-12 256.4h.1l3.6.8.5 3 5.5 2.1h0l.3-5.2 1.7 1.6h.2l2.8 1.6h0v-1.7m-91.9-277.3h0l-1.2.4-1.6.6-3.2-3.7-3.8-1.7-1.8 1.7-3.4-.2-2.8-1.3-1.1.5-.2.1-.8-.6-3.2-2.6-1.7-.5-2.2 1.2h0l-2.3-.7h0-.4l-3.7-.1-.9-6.5-2.2-3.5-2.6-.3-2.4-2.6-.4.4-.4.5-.2 3.5-1.5.3-1.8-1.4-1.9-1-2.7-.1-.7 1.6-.2.6-1.9-.1-2.3-.1-10-10.4-.9.2-2.4.5-.1-9.9V16.6h0-23.9 0-47.2 0-62.1 0v117.6h0l-.2 25.8-.4 22.9-.4 22.4v45.2h0v4.5h-40.1 0-41l-31.6-.1H20.3l-18.1.1.1 1.7.2 2.4-1.5 1.1h0l.9 1.8.9 1.8 2.5 1.1 1 1.2 1.5 1.8 1.5-.7.3-.1.4.2 2.7 1.5 3.2 5.3 1.2 3.5 1.5 1.2 1.1 3 1.2 1.1 5.1 3.2 3.4.5 1.9 1.2 1 2.7 2.5 1.1 4.4 6.3 5.6 2.8.6.7 2 2.2.1.9.1 1 3.2 3.3.3.3.5.4 3.2 2.2.8 2.6h1.5l.9.4 2.2.9 1.6 1.6 1.7-.6 2.5 2.7h.7l1.2.1.8 1.1 1.6 2.1h2.5l1.2 2.9h0l.3 1h0l.5.1 1.9.5 1.5 3.1.1.3.6 2.8.4 4.4h0l.2.1 1.7.8-.3 1.1v.1l2.1 2.4.5 1.4 2.5 2 .9 2.9-.4 2.3.4 3.1-.8 1.2h0l.3 1.1 1.1 3.6-.3 1v.1h0l5.1 8.2.7 3.3.3 1.3.2.2 3.2 3.5 2.3 1.5.6.4h0l2.7 2.7 3.2.3 2.4 1.7-.2.6-.2.7h0l2.4 3.2 2.5.9 3.8 3.1 9.9 2.5 3.2 4.1 7.2 1.1 4.1 3.9.4.4v.1l.7 1.3h0l5.9 1.9.2.4.6 1.1 2.3-.7 3.2 1 1.7-.7.3-2 .3-1.8 1.1-1.6 1.3-.4.6-.2 2.6-4 1 .6 2.6-1.8.2-.4.6-1h0l-.2-.1-1.3-.8 1.1-5 1.7-.3.7-1.8v-.3l-.2-2 1-4 .3-.3 1.3-1h0l.1-2.3 1 .1h0l.1-1.2v-.7l2.1-2.3.4-1.9.4-1.5 2.3.4 1.4-.6.8-.4.6.3.5.3h0l1.3-2 5.5.1h.1l.5-1.3.6-1.8 1.3-1.2.6-.6h0l5.5 2.1 3.4 2.3 2.9.3.5-.9 3 .6 1.6.3 1.6-.5 1.9-.6 1.8 1.2.3.2 2-.1.4.2 1.8.8 5.9-.4 1.5-2.1.1 2.5h0l1.8-.7 1.8-.7.3 1.9 1.5.2 1.4 1.8.4.5.1.5.4 1.9 2.1-.3.6.9-.5 2.8.9.7 1.3-3 .1.2.9 3.1-.9 1.4h0l3.8 1.1 1 1.9 4 .9 2.3 4.7 2.4.9 2.5 1.8.3.2.4 1.1.1.4 2.1 1.1 1.4.8 1.3 2.7-.4.7h0l4.7 4.5.9 4.9-.1 1.3-.1 1h0l2.5 2.6.5 1.7.4 1.5.8.1h.3l.6 3.2 1.1 1 .3 3.7v.2h0l2.4 1.1-.1 1.5 2.1 1.2-.5 1.5h0l1 2 2.3.7-1 .7-.5.4h0l1.4 2.4-.1.2-.5 1.3 2.7 4.2v.2l-.2 1.7 1.6 1.9 1.5.3.5 1.9h0l1.5.9.9.5 1.3.4 1.9.6 1.3 2.8 1.6 1.2 1.3 3.6 2.5.6-.2 2 .7.6.9.8v2.3h0l.9.7.4 2.7 4.4 3.1 1.9 2.6 1.5.5h.1l.6.6 1.7 1.5 2-.6.6 1.8.7-.4.3-.2 2 2.5-.8 3.2h0l2.1.9-1.1 7-.6.5-.8.6h0l1.9.7-.1 1.6 1.2.2.7.1 1.2 4.3-.6 1.3.4 2.8-.7 1-.2.3.2 2.2 1.4.3 1.7 2.1-.5 1.5h0l2.9 1.8-.3 1.3h0l2.6 1.8 1.1 2.7.1 2.1 1.4 1 .2 1.5.2 1.9 1.3 4.1.1.6v1.1l1.7.5 1.6 2.4-.3.8-.6 1.7.7.8 2.4-.1 1.3 1 1.6-.4 1.2 1.5.8-1.1 1.4 2h0l3-.8.4.5 1.2 1.3h1.6l3.3 4 1.1.6 3-1 .7 1 .4.6 1.6.2h.1l.7.6 2.7-.8v1.2l2.5 2.1h0l.4.2 1.8.8 1.3 1.6 4.8 2.3h.3l1.4.1 1-.9 2.5.1v.2l.3 1.4 1.7-1.3 2.4.5.5.1.8-.2 3.8-.7 1.2 1.1 1.4-.6h.1l1.6 1.5 1.6-.3.9-.2.6.1 2.1.4 2.7 4.4.7.1.8.1 1.2 2.4 2.9.1.1 1.4 3.5.7.2-.8.5-1.5h0l-.2-.3-.5-.7.4-.4.7-.8 3.1-.2 2.6-1.2.4-.2 2.7.4h0l-.3-3.5-4.3 3.1.5-3.8.2-1.1h0l-1.1-.9-2.2-1.9.4-1.8.3-1.6-2-6.9h0l-3.4-1.9-1.3-11.2-1.1-7.4-4-4.4.1-7.8h3.6l-1.1-4.3.7-.5 1.7-1.2h0l.1-7-3.7 1.9-5.4-2.4-6.1.1 5.9-.7h0l-3.2-6.4 4.3 5.8 4.5-1.9 2.6-3.1-.3 1.2-.9 4.3h0l3.5-1.4.4-.1.7-2 3.2-9.8 1.8-3.5 1.6-3.1-5.1-2.1-.9-5.1h0l-5.6-.5 2.4-.4 5.5-.8-1 1.2h0l4.6-1.3 1.6 2.7 1.8-2.2 1.6-1.9.1.2 4.5-7.3h0l.1-.9.2-2.3h0l-4.8 3.3-2.2 3.8h0l2.1 3.2-7.9-11.5 2.5 3.1 3.2 5h0l.9-1.7.7-1.3h0l-3.7-1.6 8.7-6.7 1.6 2.7.6.9 1.3-.1 2-.2 4.4-4.2h0l.6-3.5.2-1.4h0l-3-4.9 2.2.6 1.1.3-.1-2.3 3.4 2 2.5 3.7h0l9.5-5 .7-1.6-6.6-5.9-3.1.5 1.2-3.4h0l-2.2-3.2-.3-2"
}), React.createElement("path", {
  d: "M407.3 498.7l.7-5.8 1.8-4.8 3.7-10 .9-1.7 2.3-4.5 2.3-3.2 2.3-3.3h0l-2.1 1.1-4.6 6.4-1.4 3.2-.8 1.8-1.8 3.6-1.8 3.6-.5 2.1-1.3 5.7h.2l-.6 4.2-.5 3.3v9.2l3.6 15.1-.1.3-.6 1.1h1.4l-.6-2.6-2.8-12.4-.3-5-.1-1.5z"
}), React.createElement("path", {
  d: "M524.6 384.8l-4.1 3.7h0l2.2.3 2.7-3 .3-.4 6.5-3.9h0z"
}), React.createElement("path", {
  d: "M517.4 392.4l-.5.2-2.8 2.7-5.8 5.6h0l9.1-6.2 1.9-1.3.4-.5 1.9-2.2h0z"
}), React.createElement("path", {
  d: "M450 438.5h0l-7.3 4.7-6.5 4.2-2.9.9-2.2.7-1.2 5h0l3.4-3 3.6-3 10.8-6.6 1.8-2.2z"
}), React.createElement("path", {
  d: "M428.8 450.7h0l-2.4 3.2-1.5 2.2-3.8 8.2-.3.5 9-10.8h0z"
}), React.createElement("path", {
  d: "M420.7 463.9h0v-.3h0z"
}), React.createElement("path", {
  d: "M419.8 461.3l.2.5h0l-.2-.5h0z"
}), React.createElement("path", {
  d: "M420 461.8l.2.6h0l-.1-.2-.1-.4v.1z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Callouts"
}, React.createElement("path", {
  fill: "none",
  stroke: "#fb7d74",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M429 212.8l-74.2 169.7L490.1 361z"
}), React.createElement("circle", {
  cx: 180.1,
  cy: 161.7,
  r: 78.3,
  fill: "none",
  stroke: "#fb7d74",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4
}), React.createElement("text", {
  transform: "translate(486.376 449.253)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Texas "), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Triangle")), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(36.373 89.249)"
}, "High Plains"));

var SvgS13Colors = function SvgS13Colors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Texas",
    x: 0,
    y: 0,
    viewBox: "0 0 575 575",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "s13.colors.f41d1b75.svg";
export { SvgS13Colors as ReactComponent };